import React from 'react';
import { Tabs, Table, Button, Space, Form, Input, Select, Modal, InputNumber, Switch, DatePicker, Divider, message, Tag, Alert, Radio, Tooltip, Dropdown, Drawer } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import request from '../../../utils/request';
import { getCustomerList, getProjectList, getProjectDetail } from '../../../services/project';
import { getAllWarehouses, getWarehouseDetail } from '../../../services/warehouse';
import { getInventoryUnitDetail } from '../../../services/inventory';
import dayjs from 'dayjs';
import BillingRulesPage from './Rules';

const { TabPane } = Tabs as any;

const SystemBillingPage: React.FC = () => {
  const [loading, setLoading] = React.useState(false);
  const [opTypes, setOpTypes] = React.useState<any[]>([]);
  // 各表独立的前端分页状态
  const [summaryPage, setSummaryPage] = React.useState<number>(1);
  const [summaryPageSize, setSummaryPageSize] = React.useState<number>(50);
  const [sysOpPage, setSysOpPage] = React.useState<number>(1);
  const [sysOpPageSize, setSysOpPageSize] = React.useState<number>(50);
  const [custOpPage, setCustOpPage] = React.useState<number>(1);
  const [custOpPageSize, setCustOpPageSize] = React.useState<number>(50);
  const [projOpPage, setProjOpPage] = React.useState<number>(1);
  const [projOpPageSize, setProjOpPageSize] = React.useState<number>(50);
  const [rules, setRules] = React.useState<any[]>([]);
  const [sysRulesPage, setSysRulesPage] = React.useState<number>(1);
  const [sysRulesPageSize, setSysRulesPageSize] = React.useState<number>(50);
  const [custRulesPage, setCustRulesPage] = React.useState<number>(1);
  const [custRulesPageSize, setCustRulesPageSize] = React.useState<number>(50);
  const [projRulesPage, setProjRulesPage] = React.useState<number>(1);
  const [projRulesPageSize, setProjRulesPageSize] = React.useState<number>(50);
  const [effCustPage, setEffCustPage] = React.useState<number>(1);
  const [effCustPageSize, setEffCustPageSize] = React.useState<number>(50);
  const [effProjPage, setEffProjPage] = React.useState<number>(1);
  const [effProjPageSize, setEffProjPageSize] = React.useState<number>(50);
  const [ruleSummaryPage, setRuleSummaryPage] = React.useState<number>(1);
  const [ruleSummaryPageSize, setRuleSummaryPageSize] = React.useState<number>(20);
  const [ruleForm] = Form.useForm();
  const [opForm] = Form.useForm();
  const [visibleRuleModal, setVisibleRuleModal] = React.useState(false);
  const [modalLevel, setModalLevel] = React.useState<'system' | 'customer' | 'project'>('system');
  const [visibleOpModal, setVisibleOpModal] = React.useState(false);
  const [editingRule, setEditingRule] = React.useState<any | null>(null);
  const [editingOp, setEditingOp] = React.useState<any | null>(null);

  const [scopeLevel, setScopeLevel] = React.useState<'system' | 'customer' | 'project'>('system');
  const [scopeCustomerId, setScopeCustomerId] = React.useState<number | undefined>(undefined);
  const [scopeProjectId, setScopeProjectId] = React.useState<number | undefined>(undefined);
  const [effectiveRules, setEffectiveRules] = React.useState<any[]>([]);
  const [customerOptions, setCustomerOptions] = React.useState<Array<{ value: number; label: string }>>([]);
  const [projectOptions, setProjectOptions] = React.useState<Array<{ value: number; label: string }>>([]);
  const [customerLoading, setCustomerLoading] = React.useState(false);
  const [projectLoading, setProjectLoading] = React.useState(false);
  const [systemDebug, setSystemDebug] = React.useState<any>(null);
  const [scopedDebug, setScopedDebug] = React.useState<any>(null);
  const [ruleSaveDebug, setRuleSaveDebug] = React.useState<any>(null);
  const [activeTab, setActiveTab] = React.useState<string>('system-rules');
  // 预览语言（影响 effective 与 tiers 展示字段）
  const [previewLocale, setPreviewLocale] = React.useState<string | undefined>(undefined);

  // 展示配置 - 规则
  const [rulePresModalOpen, setRulePresModalOpen] = React.useState(false);
  const [rulePresLocale, setRulePresLocale] = React.useState<string | undefined>(undefined);
  const [rulePresTarget, setRulePresTarget] = React.useState<any | null>(null);
  const [rulePresForm] = Form.useForm();

  // 展示配置 - 操作类型
  const [opPresModalOpen, setOpPresModalOpen] = React.useState(false);
  const [opPresLocale, setOpPresLocale] = React.useState<string | undefined>(undefined);
  const [opPresTarget, setOpPresTarget] = React.useState<any | null>(null);
  const [opPresForm] = Form.useForm();
  const modalOpScope = React.useMemo(() => {
    if (activeTab === 'system-rules') return 'system';
    if (activeTab === 'customer-settings') return 'customer';
    if (activeTab === 'project-settings') return 'project';
    return 'system';
  }, [activeTab]);

  // 仓储费监控页签（最右侧）状态
  const [storageDate, setStorageDate] = React.useState<string | undefined>(undefined);
  const [storageProjectId, setStorageProjectId] = React.useState<number | undefined>(undefined);
  const [storageWarehouseId, setStorageWarehouseId] = React.useState<number | undefined>(undefined);
  const [warehouses, setWarehouses] = React.useState<Array<{ value: number; label: string }>>([]);
  const [wareLoading, setWareLoading] = React.useState(false);
  const [storageProjOptions, setStorageProjOptions] = React.useState<Array<{ value: number; label: string }>>([]);
  const [storageProjLoading, setStorageProjLoading] = React.useState(false);
  const [dailyLoading, setDailyLoading] = React.useState(false);
  const [anomalyLoading, setAnomalyLoading] = React.useState(false);
  const [dailyRows, setDailyRows] = React.useState<any[]>([]);
  const [dailyTotal, setDailyTotal] = React.useState<number>(0);
  const [anomalyRows, setAnomalyRows] = React.useState<any[]>([]);
  const [anomalyTotal, setAnomalyTotal] = React.useState<number>(0);
  const [recalcLoading, setRecalcLoading] = React.useState(false);
  const [bookLoading, setBookLoading] = React.useState(false);
  const [storageWarehouseMap, setStorageWarehouseMap] = React.useState<Record<string, string>>({});
  const [storageProjectMap, setStorageProjectMap] = React.useState<Record<string, { code?: string; name?: string }>>({});
  const [storageUnitCodeMap, setStorageUnitCodeMap] = React.useState<Record<string, string>>({});

  const ensureWarehouses = async () => {
    if (warehouses.length > 0) return;
    setWareLoading(true);
    try {
      const list = await getAllWarehouses();
      const opts = (list || []).map((w: any) => ({ value: Number(w.id), label: `${w.code || w.id} - ${w.name || ''}` }));
      setWarehouses(opts);
    } catch {
      setWarehouses([]);
    } finally { setWareLoading(false); }
  };

  const searchProjectsForMonitor = async (search?: string) => {
    setStorageProjLoading(true);
    try {
      const resp = await getProjectList({ page: 1, page_size: 50, search: search || '' });
      const results = Array.isArray((resp.data as any)?.results) ? (resp.data as any).results : [];
      const opts = results.map((p: any) => ({ value: Number(p.id), label: `${p.project_code || p.id} - ${p.name || ''}` }));
      setStorageProjOptions(opts);
    } catch (e) {
      setStorageProjOptions([]);
    } finally {
      setStorageProjLoading(false);
    }
  };

  const fetchDailyCharges = async () => {
    if (!storageDate) { message.warning('请选择日期'); return; }
    setDailyLoading(true);
    try {
      const params: any = { charge_date: storageDate };
      if (storageProjectId) params.project_id = storageProjectId;
      if (storageWarehouseId) params.warehouse_id = storageWarehouseId;
      const res = await request.get('/api/v1/billing/storage/daily-charges/', { params });
      const list = Array.isArray(res.data?.results) ? res.data.results : (Array.isArray(res.data) ? res.data : []);
      setDailyRows(list);
      setDailyTotal(Number(res.data?.count || list.length || 0));
      // 构建映射：仓库与项目
      try {
        const wids = Array.from(new Set(list.map((it: any) => it.warehouse_id).filter((x: any) => x != null)));
        const pids = Array.from(new Set(list.map((it: any) => it.project_id).filter((x: any) => x != null)));
        const uids = Array.from(new Set(list.map((it: any) => it.unit_id).filter((x: any) => x != null)));
        const wMap: Record<string, string> = { ...storageWarehouseMap };
        const pMap: Record<string, { code?: string; name?: string }> = { ...storageProjectMap };
        const uMap: Record<string, string> = { ...storageUnitCodeMap };
        await Promise.all([
          Promise.all(wids.map(async (wid: any) => {
            const key = String(wid);
            if (wMap[key]) return;
            try {
              const resp = await getWarehouseDetail(Number(wid));
              const d: any = (resp as any)?.data || resp;
              const code = d?.code || d?.warehouse_code || String(wid);
              const name = d?.name || d?.warehouse_name || '';
              wMap[key] = `${code}${name ? ` - ${name}` : ''}`;
            } catch {}
          })),
          Promise.all(pids.map(async (pid: any) => {
            const key = String(pid);
            if (pMap[key]) return;
            try {
              const resp = await getProjectDetail(Number(pid));
              const d: any = (resp as any)?.data || resp;
              pMap[key] = { code: d?.project_code || String(pid), name: d?.name || '' };
            } catch {}
          })),
          Promise.all(uids.map(async (uid: any) => {
            const key = String(uid);
            if (uMap[key]) return;
            try {
              const resp = await getInventoryUnitDetail(Number(uid));
              const d: any = (resp as any)?.data || resp;
              const code = d?.system_barcode || d?.system_code || String(uid);
              uMap[key] = code;
            } catch {}
          }))
        ]);
        setStorageWarehouseMap(wMap);
        setStorageProjectMap(pMap);
        setStorageUnitCodeMap(uMap);
      } catch {}
    } catch (e: any) {
      message.error(e?.message || '加载日度明细失败');
      setDailyRows([]); setDailyTotal(0);
    } finally { setDailyLoading(false); }
  };

  const fetchAnomalies = async () => {
    if (!storageDate) { message.warning('请选择日期'); return; }
    setAnomalyLoading(true);
    try {
      const params: any = { charge_date: storageDate };
      if (storageProjectId) params.project_id = storageProjectId;
      if (storageWarehouseId) params.warehouse_id = storageWarehouseId;
      const res = await request.get('/api/v1/billing/storage/anomalies/', { params });
      const list = Array.isArray(res.data?.results) ? res.data.results : (Array.isArray(res.data) ? res.data : []);
      setAnomalyRows(list);
      setAnomalyTotal(Number(res.data?.count || list.length || 0));
      // 构建映射：仓库与项目（异常列表中也可能出现新的ID）
      try {
        const wids = Array.from(new Set(list.map((it: any) => it.warehouse_id).filter((x: any) => x != null)));
        const pids = Array.from(new Set(list.map((it: any) => it.project_id).filter((x: any) => x != null)));
        const uids = Array.from(new Set(list.map((it: any) => it.unit_id).filter((x: any) => x != null)));
        const wMap: Record<string, string> = { ...storageWarehouseMap };
        const pMap: Record<string, { code?: string; name?: string }> = { ...storageProjectMap };
        const uMap: Record<string, string> = { ...storageUnitCodeMap };
        await Promise.all([
          Promise.all(wids.map(async (wid: any) => {
            const key = String(wid);
            if (wMap[key]) return;
            try {
              const resp = await getWarehouseDetail(Number(wid));
              const d: any = (resp as any)?.data || resp;
              const code = d?.code || d?.warehouse_code || String(wid);
              const name = d?.name || d?.warehouse_name || '';
              wMap[key] = `${code}${name ? ` - ${name}` : ''}`;
            } catch {}
          })),
          Promise.all(pids.map(async (pid: any) => {
            const key = String(pid);
            if (pMap[key]) return;
            try {
              const resp = await getProjectDetail(Number(pid));
              const d: any = (resp as any)?.data || resp;
              pMap[key] = { code: d?.project_code || String(pid), name: d?.name || '' };
            } catch {}
          })),
          Promise.all(uids.map(async (uid: any) => {
            const key = String(uid);
            if (uMap[key]) return;
            try {
              const resp = await getInventoryUnitDetail(Number(uid));
              const d: any = (resp as any)?.data || resp;
              const code = d?.system_barcode || d?.system_code || String(uid);
              uMap[key] = code;
            } catch {}
          }))
        ]);
        setStorageWarehouseMap(wMap);
        setStorageProjectMap(pMap);
        setStorageUnitCodeMap(uMap);
      } catch {}
    } catch (e: any) {
      message.error(e?.message || '加载异常失败');
      setAnomalyRows([]); setAnomalyTotal(0);
    } finally { setAnomalyLoading(false); }
  };

  const execRecalc = async () => {
    if (!storageDate) { message.warning('请选择日期'); return; }
    setRecalcLoading(true);
    try {
      const body: any = { start_date: storageDate, end_date: storageDate };
      if (storageProjectId) body.project_id = storageProjectId;
      if (storageWarehouseId) body.warehouse_id = storageWarehouseId;
      await request.post('/api/v1/billing/storage/daily-charges/recalc/', body);
      message.success('已触发重算');
    } catch (e: any) {
      message.error(e?.message || '重算失败');
    } finally { setRecalcLoading(false); }
  };

  const execBook = async () => {
    if (!storageDate) { message.warning('请选择日期'); return; }
    setBookLoading(true);
    try {
      const body: any = { charge_date: storageDate };
      if (storageProjectId) body.project_id = storageProjectId;
      if (storageWarehouseId) body.warehouse_id = storageWarehouseId;
      await request.post('/api/v1/billing/storage/daily-charges/book/', body);
      message.success('已过账到收费记录');
    } catch (e: any) {
      message.error(e?.message || '过账失败');
    } finally { setBookLoading(false); }
  };

  // 打开"规则展示配置"弹窗：优先读取已存在的规则级展示覆盖
  const openRulePresentation = async (record: any) => {
    setRulePresTarget(record);
    const loc = previewLocale || 'zh-CN';
    setRulePresLocale(loc);
    try {
      const list = await request.get('/api/v1/billing/presentations/billing-rules/', { params: { rule: record.id, locale: loc } });
      const exist = Array.isArray(list.data?.results) ? (list.data.results[0] || null) : (Array.isArray(list.data) ? list.data[0] : null);
      if (exist) {
        rulePresForm.setFieldsValue({
          display_name_override: exist.display_name_override || '',
          description_override: exist.description_override || '',
          examples_override: exist.examples_override || '',
          unit_label_override: exist.unit_label_override || '',
          rule_remark_override: exist.rule_remark_override || '',
        });
      } else {
        // 无既有覆盖时，回填当前展示值（effective 列表或规则列表提供的字段）
        rulePresForm.setFieldsValue({
          display_name_override: record.display_name || record.operation_type_name || '',
          description_override: record.description || '',
          examples_override: record.examples || '',
          unit_label_override: record.unit_label || '',
          rule_remark_override: record.rule_remark || record.remark || '',
        });
      }
    } catch (e) {
      rulePresForm.setFieldsValue({
        display_name_override: record.display_name || record.operation_type_name || '',
        description_override: record.description || '',
        examples_override: record.examples || '',
        unit_label_override: record.unit_label || '',
        rule_remark_override: record.rule_remark || record.remark || '',
      });
    }
    setRulePresModalOpen(true);
  };

  // 显示用：根据已加载的下拉选项，取"名称 · 编码 / 编码 - 名称"
  const getCustomerLabel = React.useCallback((id?: number) => {
    if (!id) return '-';
    const item = customerOptions.find(o => o.value === id);
    return item?.label || String(id);
  }, [customerOptions]);
  const getProjectLabel = React.useCallback((id?: number) => {
    if (!id) return '-';
    const item = projectOptions.find(o => o.value === id);
    return item?.label || String(id);
  }, [projectOptions]);

  // 操作类型字典汇总用：使用级别、适用客户/项目
  const [opUsage, setOpUsage] = React.useState<Record<number, { system: boolean; customers: number[]; projects: number[] }>>({});
  const [customerMap, setCustomerMap] = React.useState<Record<number, string>>({});
  const [projectMap, setProjectMap] = React.useState<Record<number, string>>({});

  // 汇总页筛选（作用域/客户/项目/关键字/类别）
  const [summaryFilterLevel, setSummaryFilterLevel] = React.useState<'all' | 'system' | 'customer' | 'project'>('all');
  const [summaryFilterCustomerId, setSummaryFilterCustomerId] = React.useState<number | undefined>(undefined);
  const [summaryFilterProjectId, setSummaryFilterProjectId] = React.useState<number | undefined>(undefined);
  const [summaryProjectOptions, setSummaryProjectOptions] = React.useState<Array<{ value: number; label: string }>>([]);
  const [summaryProjectLoading, setSummaryProjectLoading] = React.useState(false);
  const [summaryKeyword, setSummaryKeyword] = React.useState<string>('');
  const [summaryCategory, setSummaryCategory] = React.useState<string | undefined>(undefined);

  // 收费规则汇总 - 过滤与数据
  const [ruleSummaryFilterLevel, setRuleSummaryFilterLevel] = React.useState<'all' | 'system' | 'customer' | 'project'>('all');
  const [ruleSummaryCustomerId, setRuleSummaryCustomerId] = React.useState<number | undefined>(undefined);
  const [ruleSummaryProjectId, setRuleSummaryProjectId] = React.useState<number | undefined>(undefined);
  const [ruleSummaryProjectOptions, setRuleSummaryProjectOptions] = React.useState<Array<{ value: number; label: string }>>([]);
  const [ruleSummaryProjectLoading, setRuleSummaryProjectLoading] = React.useState(false);
  const [ruleSummary, setRuleSummary] = React.useState<any[]>([]);
  const [ruleSummaryCategory, setRuleSummaryCategory] = React.useState<string | undefined>(undefined);
  const [ruleSummaryType, setRuleSummaryType] = React.useState<'all' | 'flat' | 'tiered'>('all');
  // 系统级规则筛选
  const [sysRulesCategory, setSysRulesCategory] = React.useState<string | undefined>(undefined);
  const [sysRulesType, setSysRulesType] = React.useState<'all' | 'flat' | 'tiered'>('all');
  // 梯度查看（汇总用，只读）
  const [tierViewOpen, setTierViewOpen] = React.useState(false);
  const [tierViewRule, setTierViewRule] = React.useState<any | null>(null);
  const [tierViewList, setTierViewList] = React.useState<any[]>([]);
  const [tierViewLoading, setTierViewLoading] = React.useState(false);

  // 显示用映射：梯度维度中文
  const tierBasisLabel = React.useCallback((v?: string) => ({
    QUANTITY: '数量',
    WEIGHT_G: '重量(克)',
    WEIGHT_KG: '重量(千克)',
    VOLUME_CUFT: '体积(ft³)',
    VOLUME_CBM: '体积(m³)',
    VOLUME_CC: '体积(cm³)',
    AGE_DAY: '库龄(天)'
  } as any)[v || ''] || '-', []);
  // 系统级操作类型过滤
  const [sysOpKeyword, setSysOpKeyword] = React.useState<string>('');
  const [sysOpCategoryFilter, setSysOpCategoryFilter] = React.useState<string | undefined>(undefined);

  // 通用排序：按序号后按名称
  const compareOpTypeByOrderThenName = React.useCallback((a: any, b: any) => {
    const oi = (a?.order_index || 0) - (b?.order_index || 0);
    if (oi !== 0) return oi;
    const an = ((a?.name ?? '') + '').toString();
    const bn = ((b?.name ?? '') + '').toString();
    return an.localeCompare(bn);
  }, []);

  // 过滤视图：客户级/项目级操作类型列表（仅显示本层作用域）
  const systemScopedOpTypes = React.useMemo(() => {
    return (opTypes || []).filter((ot: any) => {
      const scopes = Array.isArray(ot.scopes) ? ot.scopes : [];
      // 无作用域记录时，默认视为系统可见；或显式 system 作用域
      return scopes.length === 0 || scopes.some((s: any) => s.scope_level === 'system');
    }).sort(compareOpTypeByOrderThenName);
  }, [opTypes, compareOpTypeByOrderThenName]);

  const customerScopedOpTypes = React.useMemo(() => {
    return (opTypes || []).filter((ot: any) => {
      const scopes = Array.isArray(ot.scopes) ? ot.scopes : [];
      if (!scopeCustomerId) {
        // 未选择客户时：显示所有"客户级"操作类型
        return scopes.some((s: any) => s.scope_level === 'customer');
      }
      // 选择客户后：仅显示该客户相关操作类型
      return scopes.some((s: any) => s.scope_level === 'customer' && Number(s.customer_id) === Number(scopeCustomerId));
    }).sort(compareOpTypeByOrderThenName);
  }, [opTypes, scopeCustomerId, compareOpTypeByOrderThenName]);

  const projectScopedOpTypes = React.useMemo(() => {
    return (opTypes || []).filter((ot: any) => {
      const scopes = Array.isArray(ot.scopes) ? ot.scopes : [];
      if (!scopeCustomerId || !scopeProjectId) {
        // 未选择客户/项目时：显示所有"项目级"操作类型
        return scopes.some((s: any) => s.scope_level === 'project');
      }
      // 选择客户+项目后：仅显示该项目相关操作类型
      return scopes.some((s: any) => s.scope_level === 'project' && Number(s.customer_id) === Number(scopeCustomerId) && Number(s.project_id) === Number(scopeProjectId));
    }).sort(compareOpTypeByOrderThenName);
  }, [opTypes, scopeCustomerId, scopeProjectId, compareOpTypeByOrderThenName]);

  // 操作类型ID -> 类别 映射（用于规则汇总按类别筛选）
  const opTypeCategoryMap = React.useMemo(() => {
    const m: Record<number, string> = {};
    (opTypes || []).forEach((o: any) => {
      if (o && o.id != null) m[Number(o.id)] = o.category;
    });
    return m;
  }, [opTypes]);

  // 规则表单：操作类型下拉选项（确保包含当前编辑记录对应选项，避免只显示ID）
  const opTypeOptionsForModal = React.useMemo(() => {
    const baseList = modalLevel === 'project'
      ? projectScopedOpTypes
      : (modalLevel === 'customer' ? customerScopedOpTypes : systemScopedOpTypes);
    const opts = baseList.map(o => ({ value: o.id, label: `${o.name} (${o.system_code})` }));
    if (editingRule?.operation_type && !opts.some(o => Number(o.value) === Number(editingRule.operation_type))) {
      const found = (opTypes || []).find((o: any) => Number(o.id) === Number(editingRule.operation_type));
      if (found) {
        opts.unshift({ value: found.id, label: `${found.name} (${found.system_code})` });
      }
    }
    return opts;
  }, [modalLevel, projectScopedOpTypes, customerScopedOpTypes, systemScopedOpTypes, editingRule, opTypes]);

  // 汇总卡片：最终筛选后的数据（用于正确分页 total）
  const summaryFiltered = React.useMemo(() => {
    const kw = (summaryKeyword || '').trim().toLowerCase();
    return (opTypes || []).filter((ot: any) => {
      if (kw) {
        const hay = `${ot.name || ''} ${ot.system_code || ''} ${ot.description || ''}`.toLowerCase();
        if (!hay.includes(kw)) return false;
      }
      if (summaryCategory && ot.category !== summaryCategory) return false;
      const scopes = Array.isArray(ot.scopes) ? ot.scopes : [];
      if (summaryFilterLevel !== 'all') {
        const okLevel = scopes.some((s: any) => s.scope_level === summaryFilterLevel);
        if (!okLevel) return false;
      }
      if (summaryFilterCustomerId) {
        const okCust = scopes.some((s: any) => (s.scope_level === 'customer' || s.scope_level === 'project') && Number(s.customer_id) === Number(summaryFilterCustomerId));
        if (!okCust) return false;
      }
      if (summaryFilterProjectId) {
        const okProj = scopes.some((s: any) => s.scope_level === 'project' && Number(s.project_id) === Number(summaryFilterProjectId));
        if (!okProj) return false;
      }
      return true;
    });
  }, [opTypes, summaryKeyword, summaryCategory, summaryFilterLevel, summaryFilterCustomerId, summaryFilterProjectId]);

  // 系统级操作类型：筛选后的数据
  const systemOpsFiltered = React.useMemo(() => {
    const kw = (sysOpKeyword || '').trim().toLowerCase();
    return systemScopedOpTypes.filter((ot: any) => {
      if (kw) {
        const hay = `${ot.name || ''} ${ot.system_code || ''} ${ot.description || ''}`.toLowerCase();
        if (!hay.includes(kw)) return false;
      }
      if (sysOpCategoryFilter && ot.category !== sysOpCategoryFilter) return false;
      return true;
    }).sort(compareOpTypeByOrderThenName);
  }, [systemScopedOpTypes, sysOpKeyword, sysOpCategoryFilter, compareOpTypeByOrderThenName]);

  // 收费规则汇总：筛选后的数据
  const ruleSummaryFiltered = React.useMemo(() => {
    const filtered = ruleSummary.filter((r: any) => {
      if (ruleSummaryFilterLevel !== 'all' && r.rule_level !== ruleSummaryFilterLevel) return false;
      if (ruleSummaryCustomerId && Number(r.customer_id) !== Number(ruleSummaryCustomerId)) return false;
      if (ruleSummaryProjectId && Number(r.project_id) !== Number(ruleSummaryProjectId)) return false;
      if (ruleSummaryCategory && r.operation_type_category !== ruleSummaryCategory) return false;
      if (ruleSummaryType !== 'all' && r.rule_type !== ruleSummaryType) return false;
      return true;
    });
    return filtered.sort((a: any, b: any) => (a.operation_type_order_index || 0) - (b.operation_type_order_index || 0)
      || String(a.operation_type_name||'').localeCompare(String(b.operation_type_name||''))
      || String(a.min_value||'').localeCompare(String(b.min_value||''))
      || String(a.max_value||'').localeCompare(String(b.max_value||''))
    );
  }, [ruleSummary, ruleSummaryFilterLevel, ruleSummaryCustomerId, ruleSummaryProjectId, ruleSummaryCategory, ruleSummaryType]);

  // 系统级规则：筛选后的数据
  const sysRulesFiltered = React.useMemo(() => {
    return (rules || []).filter((r: any) => {
      if (sysRulesType !== 'all' && r.rule_type !== sysRulesType) return false;
      if (sysRulesCategory && r.operation_type_category !== sysRulesCategory) return false;
      return true;
    });
  }, [rules, sysRulesType, sysRulesCategory]);

  const fetchOpTypes = async () => {
    const res = await request.get('/api/v1/billing/operation-types/', { params: { all: 1 } });
    const list = res.data?.results || res.data || [];
    // 调试：打印返回条数与首条 scopes
    try { console.debug('[opTypes.fetch] count=', Array.isArray(list) ? list.length : 'n/a', 'first.scopes=', Array.isArray(list) && list[0] ? list[0].scopes : undefined); } catch {}
    setOpTypes(list);
  };

  // 客户/项目级规则与"最终生效规则"筛选占位（当前无额外筛选条件，先与原数据一致，便于统一分页计算）
  const custRulesFiltered = React.useMemo(() => rules, [rules]);
  const projRulesFiltered = React.useMemo(() => rules, [rules]);
  // 本层物化规则独立筛选（客户/项目）
  const [custRulesType, setCustRulesType] = React.useState<'all' | 'flat' | 'tiered'>('all');
  const [custRulesCategory, setCustRulesCategory] = React.useState<string | undefined>(undefined);
  const [projRulesType, setProjRulesType] = React.useState<'all' | 'flat' | 'tiered'>('all');
  const [projRulesCategory, setProjRulesCategory] = React.useState<string | undefined>(undefined);

  const custRulesFiltered2 = React.useMemo(() => {
    return (custRulesFiltered || []).filter((r: any) => {
      if (custRulesType !== 'all' && r.rule_type !== custRulesType) return false;
      if (custRulesCategory && r.operation_type_category !== custRulesCategory) return false;
      return true;
    });
  }, [custRulesFiltered, custRulesType, custRulesCategory]);

  const projRulesFiltered2 = React.useMemo(() => {
    return (projRulesFiltered || []).filter((r: any) => {
      if (projRulesType !== 'all' && r.rule_type !== projRulesType) return false;
      if (projRulesCategory && r.operation_type_category !== projRulesCategory) return false;
      return true;
    });
  }, [projRulesFiltered, projRulesType, projRulesCategory]);
  // 最终生效规则筛选（客户/项目）
  const [effCustType, setEffCustType] = React.useState<'all' | 'flat' | 'tiered'>('all');
  const [effCustCategory, setEffCustCategory] = React.useState<string | undefined>(undefined);
  const [effCustSource, setEffCustSource] = React.useState<'all' | 'system' | 'customer' | 'project'>('all');
  const [effProjType, setEffProjType] = React.useState<'all' | 'flat' | 'tiered'>('all');
  const [effProjCategory, setEffProjCategory] = React.useState<string | undefined>(undefined);
  const [effProjSource, setEffProjSource] = React.useState<'all' | 'system' | 'customer' | 'project'>('all');

  const [effCustOnlyMasked, setEffCustOnlyMasked] = React.useState<boolean>(false);
  const [effCustOnlyCovered, setEffCustOnlyCovered] = React.useState<boolean>(false);
  const effCustomerFiltered = React.useMemo(() => {
    return (effectiveRules || []).filter((r: any) => {
      if (effCustType !== 'all' && r.rule_type !== effCustType) return false;
      if (effCustCategory && r.operation_type_category !== effCustCategory) return false;
      if (effCustSource !== 'all' && (r.source_level ?? r.rule_level) !== effCustSource) return false;
      if (effCustOnlyMasked && !r.is_masked) return false;
      if (effCustOnlyCovered && !(r.is_covered || (r.inherited_from_rule && !r.is_masked))) return false;
      return true;
    });
  }, [effectiveRules, effCustType, effCustCategory, effCustSource, effCustOnlyMasked, effCustOnlyCovered]);

  const [effProjOnlyMasked, setEffProjOnlyMasked] = React.useState<boolean>(false);
  const [effProjOnlyCovered, setEffProjOnlyCovered] = React.useState<boolean>(false);
  const effProjectFiltered = React.useMemo(() => {
    return (effectiveRules || []).filter((r: any) => {
      if (effProjType !== 'all' && r.rule_type !== effProjType) return false;
      if (effProjCategory && r.operation_type_category !== effProjCategory) return false;
      if (effProjSource !== 'all' && (r.source_level ?? r.rule_level) !== effProjSource) return false;
      if (effProjOnlyMasked && !r.is_masked) return false;
      if (effProjOnlyCovered && !(r.is_covered || (r.inherited_from_rule && !r.is_masked))) return false;
      return true;
    });
  }, [effectiveRules, effProjType, effProjCategory, effProjSource, effProjOnlyMasked, effProjOnlyCovered]);

  const fetchRulesByScope = async () => {
    if (scopeLevel === 'system') {
      const res = await request.get('/api/v1/billing/billing-rules/', { params: { rule_level: 'system', all: 1 } });
      setRules(res.data?.results || res.data || []);
      setEffectiveRules([]);
      setSystemDebug((res.data && (res.data as any).debug) ? (res.data as any).debug : null);
    } else if (scopeLevel === 'customer') {
      const res = await request.get('/api/v1/billing/billing-rules/', { params: { rule_level: 'customer', customer_id: scopeCustomerId, all: 1 } });
      setRules(res.data?.results || res.data || []);
      const eff = await request.get('/api/v1/billing/billing-rules/effective/', { params: { customer_id: scopeCustomerId, locale: previewLocale } });
      setEffectiveRules(eff.data || []);
      setScopedDebug((res.data && (res.data as any).debug) ? (res.data as any).debug : null);
    } else {
      const res = await request.get('/api/v1/billing/billing-rules/', { params: { rule_level: 'project', customer_id: scopeCustomerId, project_id: scopeProjectId, all: 1 } });
      setRules(res.data?.results || res.data || []);
      const eff = await request.get('/api/v1/billing/billing-rules/effective/', { params: { customer_id: scopeCustomerId, project_id: scopeProjectId, locale: previewLocale } });
      setEffectiveRules(eff.data || []);
      setScopedDebug((res.data && (res.data as any).debug) ? (res.data as any).debug : null);
    }
  };

  const fetchSystemRulesOnly = async () => {
    setLoading(true);
    try {
      const res = await request.get('/api/v1/billing/billing-rules/', { params: { rule_level: 'system', all: 1 } });
      setRules(res.data?.results || res.data || []);
      setSystemDebug((res.data && (res.data as any).debug) ? (res.data as any).debug : null);
    } finally {
      setLoading(false);
    }
  };

  // 加载收费规则汇总（系统/客户/项目）
  const fetchRuleSummary = async () => {
    setLoading(true);
    try {
      const [sysRes, custRes, projRes] = await Promise.all([
        request.get('/api/v1/billing/billing-rules/', { params: { rule_level: 'system', all: 1 } }),
        request.get('/api/v1/billing/billing-rules/', { params: { rule_level: 'customer', all: 1 } }),
        request.get('/api/v1/billing/billing-rules/', { params: { rule_level: 'project', all: 1 } }),
      ]);
      const sys = (sysRes.data?.results || sysRes.data || []).map((r: any) => ({ ...r, source_level: 'system' }));
      const cust = (custRes.data?.results || custRes.data || []).map((r: any) => ({ ...r, source_level: 'customer' }));
      const proj = (projRes.data?.results || projRes.data || []).map((r: any) => ({ ...r, source_level: 'project' }));
      setRuleSummary([...
        sys,
        ...cust,
        ...proj,
      ]);
    } finally {
      setLoading(false);
    }
  };

  const openTierView = async (rule: any) => {
    setTierViewRule(rule);
    setTierViewOpen(true);
    setTierViewLoading(true);
    try {
      const res = await request.get(`/api/v1/billing/billing-rules/${rule.id}/tiers/`, { params: { locale: previewLocale } });
      setTierViewList(res.data || []);
    } finally {
      setTierViewLoading(false);
    }
  };

  React.useEffect(() => {
    // 首屏即进入系统级上下文并刷新系统级规则
    setScopeLevel('system');
    setActiveTab('system-rules');
    setLoading(true);
    Promise.all([fetchOpTypes(), fetchSystemRulesOnly()]).then(async () => {
      await buildOpTypeUsageSummary();
      await fetchRuleSummary();
    }).finally(() => setLoading(false));
  }, []);

  React.useEffect(() => {
    if (scopeLevel === 'customer' && !scopeCustomerId) {
      setRules([]);
      setEffectiveRules([]);
      return;
    }
    if (scopeLevel === 'project' && (!scopeCustomerId || !scopeProjectId)) {
      setRules([]);
      setEffectiveRules([]);
      return;
    }
    setLoading(true);
    fetchRulesByScope().finally(() => setLoading(false));
  }, [scopeLevel, scopeCustomerId, scopeProjectId]);

  // 【收费规则汇总】按筛选条件或切换到该卡片时自动刷新
  React.useEffect(() => {
    if (activeTab === 'rule-summary') {
      fetchRuleSummary();
    }
  }, [activeTab, ruleSummaryFilterLevel, ruleSummaryCustomerId, ruleSummaryProjectId]);

  // 切换到三个"规则设置"页签或满足必要条件后，自动刷新无需手动点击
  React.useEffect(() => {
    if (activeTab === 'system-rules') {
      fetchOpTypes();
      fetchSystemRulesOnly();
      return;
    }
    if (activeTab === 'customer-settings') {
      if (scopeCustomerId) {
        fetchRulesByScope();
      }
      return;
    }
    if (activeTab === 'project-settings') {
      if (scopeCustomerId && scopeProjectId) {
        fetchRulesByScope();
      }
    }
  }, [activeTab, scopeCustomerId, scopeProjectId]);

  // 下拉加载 - 客户
  const ensureCustomersLoaded = async () => {
    if (customerOptions.length > 0) return;
    setCustomerLoading(true);
    try {
      const list = await getCustomerList({ onlyMain: true });
      const opts = (list || []).map((c: any) => {
        const sys = c.customer_code || c.profile?.customer_code || '';
        const name = c.name || c.username;
        const label = sys ? `${name} · ${sys}` : (name || '');
        return { value: Number(c.id), label };
      });
      setCustomerOptions(opts);
    } catch (e) {
      // ignore
    } finally {
      setCustomerLoading(false);
    }
  };

  // 构建"操作类型字典汇总"使用信息：从三层规则反推操作类型级别与适用客户/项目
  const buildOpTypeUsageSummary = async () => {
    try {
      const [sysRes, custRes, projRes] = await Promise.all([
        request.get('/api/v1/billing/billing-rules/', { params: { rule_level: 'system', all: 1 } }),
        request.get('/api/v1/billing/billing-rules/', { params: { rule_level: 'customer', all: 1 } }),
        request.get('/api/v1/billing/billing-rules/', { params: { rule_level: 'project', all: 1 } }),
      ]);
      const sys = (sysRes.data?.results || sysRes.data || []) as any[];
      const cust = (custRes.data?.results || custRes.data || []) as any[];
      const proj = (projRes.data?.results || projRes.data || []) as any[];
      const usage: Record<number, { system: boolean; customers: number[]; projects: number[] }> = {};
      const add = (opId: number, kind: 'system'|'customer'|'project', cid?: number|null, pid?: number|null) => {
        if (!opId) return;
        if (!usage[opId]) usage[opId] = { system: false, customers: [], projects: [] };
        if (kind === 'system') usage[opId].system = true;
        if (kind === 'customer' && cid) {
          if (!usage[opId].customers.includes(cid)) usage[opId].customers.push(cid);
        }
        if (kind === 'project' && pid) {
          if (!usage[opId].projects.includes(pid)) usage[opId].projects.push(pid);
        }
      };
      sys.forEach(r => add(r.operation_type, 'system'));
      cust.forEach(r => add(r.operation_type, 'customer', r.customer_id ?? null, null));
      proj.forEach(r => add(r.operation_type, 'project', r.customer_id ?? null, r.project_id ?? null));
      setOpUsage(usage);
      // 构建客户名称映射
      try {
        const list = await getCustomerList({ onlyMain: true });
        const cmap: Record<number, string> = {};
        (list || []).forEach((c: any) => {
          const sys = c.customer_code || c.profile?.customer_code || '';
          const name = c.name || c.username;
          const label = sys ? `${name} · ${sys}` : (name || '');
          cmap[Number(c.id)] = label;
        });
      setCustomerMap(cmap);
      } catch {}
      // 构建项目名称映射（基于 scopes 收集到的 (customer_id, project_id) 集合批量查询）
      const customerToProjectIds: Record<number, Set<number>> = {};
      try {
        (opTypes || []).forEach((ot: any) => {
          const scopes = Array.isArray(ot.scopes) ? ot.scopes : [];
          scopes.forEach((s: any) => {
            if (s.scope_level === 'project' && s.customer_id && s.project_id) {
              if (!customerToProjectIds[s.customer_id]) customerToProjectIds[s.customer_id] = new Set<number>();
              customerToProjectIds[s.customer_id].add(Number(s.project_id));
            }
          });
        });
      } catch {}
      const pmap: Record<number, string> = {};
      for (const cidStr of Object.keys(customerToProjectIds)) {
        const cid = Number(cidStr);
        try {
          const resp = await getProjectList({ page: 1, page_size: 500, search: '', customer: cid });
          const results = Array.isArray((resp.data as any)?.results) ? (resp.data as any).results : [];
          results.forEach((p: any) => {
            const label = `${p.project_code || p.id} - ${p.name}`;
            pmap[Number(p.id)] = label;
          });
        } catch {}
      }
      setProjectMap(pmap);
      try { console.debug('[opTypes.usage] usage.keys=', Object.keys(usage).length); } catch {}
    } catch {
      // ignore
    }
  };

  // 下拉/搜索 - 项目（按客户过滤，远程搜索）
  const searchProjects = async (search?: string) => {
    if (!scopeCustomerId) { setProjectOptions([]); return; }
    setProjectLoading(true);
    try {
      const resp = await getProjectList({ page: 1, page_size: 50, search: search || '', customer: scopeCustomerId });
      const results = Array.isArray((resp.data as any)?.results) ? (resp.data as any).results : [];
      const opts = results.map((p: any) => ({ value: Number(p.id), label: `${p.project_code || p.id} - ${p.name}` }));
      setProjectOptions(opts);
    } catch (e) {
      setProjectOptions([]);
    } finally {
      setProjectLoading(false);
    }
  };

  const columnsOp = [
    { title: '系统编码', dataIndex: 'system_code' },
    { title: '名称', dataIndex: 'name' },
    { title: '类别', dataIndex: 'category' },
    { title: '序号', dataIndex: 'order_index' },
    { title: (
      <span>
        状态
        <Tooltip title="未屏蔽且启用=参与计费；已屏蔽且启用=屏蔽生效（阻断回退，不计费）；禁用=该记录不生效/屏蔽关闭。">
          <QuestionCircleOutlined style={{ marginLeft: 6, color: '#999' }} />
        </Tooltip>
      </span>
    ), dataIndex: 'is_active', render: (v: boolean, r: any) => {
      if (r?.is_masked && v) return <Tag color="red">屏蔽</Tag>;
      if (v) return <Tag color="green">启用</Tag>;
      return <Tag style={{ color: '#cf1322', background: '#fff1f0', borderColor: '#ffa39e' }}>禁用</Tag>;
    } },
    {
      title: '操作',
      render: (_: any, record: any) => (
        <Space>
          <Button size="small" onClick={() => {
            setEditingOp(record);
            opForm.setFieldsValue(record);
            setVisibleOpModal(true);
          }}>编辑</Button>
          <Button size="small" danger onClick={() => {
            Modal.confirm({
              icon: null,
              title: '确认删除该操作类型？',
              content: (
                <div>
                  <div>删除将移除该操作类型。若存在关联收费规则，后端可能拒绝删除。</div>
                </div>
              ),
              okText: '删除',
              okButtonProps: { danger: true },
              cancelText: '取消',
              onOk: async () => {
                setLoading(true);
                try {
                  await request.delete(`/api/v1/billing/operation-types/${record.id}/`);
                  message.success('已删除操作类型');
                  await fetchOpTypes();
                  await buildOpTypeUsageSummary();
                } catch (e: any) {
                  message.error(e?.response?.data?.detail || e?.message || '删除失败');
                } finally { setLoading(false); }
              }
            });
          }}>删除</Button>
          <Button size="small" type="default" style={record.is_active ? undefined : { background: '#e6f4ff', borderColor: '#91caff', color: '#1677ff' }} onClick={async () => {
            if (record.is_active) {
              // 提供运维选项：仅禁用；禁用并批量停用规则
              const modal = Modal.confirm({
                icon: null,
                title: '禁用操作类型',
                content: (
                  <div>
                    <div className="mb-2">请选择禁用策略：</div>
                    <Space>
                      <Button onClick={async () => {
                        modal.destroy();
                        setLoading(true);
                        try {
                          await request.put(`/api/v1/billing/operation-types/${record.id}/`, {
                            name: record.name,
                            category: record.category,
                            description: record.description,
                            is_active: false,
                          });
                          message.success('已禁用操作类型');
                          await fetchOpTypes();
                          await buildOpTypeUsageSummary();
                        } finally { setLoading(false); }
                      }}>仅禁用操作类型</Button>
                      <Button type="primary" danger onClick={async () => {
                        modal.destroy();
                        setLoading(true);
                        try {
                          // 1) 禁用操作类型
                          await request.put(`/api/v1/billing/operation-types/${record.id}/`, {
                            name: record.name,
                            category: record.category,
                            description: record.description,
                            is_active: false,
                          });
                          // 2) 批量停用关联规则（系统/客户/项目）
                          const res = await request.get('/api/v1/billing/billing-rules/', { params: { operation_type: record.id, all: 1 } });
                          const list = res.data?.results || res.data || [];
                          await Promise.all((list as any[]).map(r => request.put(`/api/v1/billing/billing-rules/${r.id}/`, {
                            rule_level: r.rule_level,
                            customer_id: r.customer_id,
                            project_id: r.project_id,
                            operation_type: r.operation_type,
                            billing_unit: r.billing_unit,
                            min_value: r.min_value,
                            max_value: r.max_value,
                            unit_price: r.unit_price,
                            currency: r.currency,
                            effective_from: r.effective_from,
                            effective_to: r.effective_to,
                            is_active: false,
                            disabled_via_optype: true,
                            is_masked: r.is_masked,
                            rule_type: r.rule_type,
                            tier_basis: r.tier_basis,
                            accrual_period: r.accrual_period,
                          })));
                          message.success('已禁用操作类型并批量停用关联规则');
                          await fetchOpTypes();
                          await buildOpTypeUsageSummary();
                        } finally { setLoading(false); }
                      }}>禁用并批量停用规则</Button>
                      <Button onClick={() => modal.destroy()}>取消</Button>
                    </Space>
                  </div>
                ),
                okButtonProps: { style: { display: 'none' } },
                cancelButtonProps: { style: { display: 'none' } },
              });
            } else {
              // 启用
              const payload: any = {
                name: record.name,
                category: record.category,
                description: record.description,
                is_active: true,
              };
              setLoading(true);
              try {
                await request.put(`/api/v1/billing/operation-types/${record.id}/`, payload);
                // 级联恢复：仅恢复因操作类型级联禁用的规则（disabled_via_optype=true）
                const res = await request.get('/api/v1/billing/billing-rules/', { params: { operation_type: record.id, all: 1 } });
                const list = res.data?.results || res.data || [];
                const needRestore = (list as any[]).filter((r: any) => r.disabled_via_optype === true);
                if (needRestore.length > 0) {
                  await Promise.all(needRestore.map(r => request.put(`/api/v1/billing/billing-rules/${r.id}/`, {
                    rule_level: r.rule_level,
                    customer_id: r.customer_id,
                    project_id: r.project_id,
                    operation_type: r.operation_type,
                    billing_unit: r.billing_unit,
                    min_value: r.min_value,
                    max_value: r.max_value,
                    unit_price: r.unit_price,
                    currency: r.currency,
                    effective_from: r.effective_from,
                    effective_to: r.effective_to,
                    is_active: true,
                    disabled_via_optype: false,
                    is_masked: r.is_masked,
                    rule_type: r.rule_type,
                    tier_basis: r.tier_basis,
                    accrual_period: r.accrual_period,
                  })));
                }
                message.success('已启用');
                await fetchOpTypes();
                await buildOpTypeUsageSummary();
              } finally { setLoading(false); }
            }
          }}>{record.is_active ? '禁用' : '启用'}</Button>
        </Space>
      )
    }
  ];

  // 本层物化规则：与最终生效列基本一致，但备注字段为 remark
  const columnsMaterialized = [
    { title: '来源', render: (_: any, r: any) => <Tag>{(r && (r.source_level ?? r.rule_level)) || '-'}</Tag> },
    { title: '操作类型', dataIndex: 'operation_type_name' },
    { title: '类型', dataIndex: 'rule_type', render: (v: string) => v === 'tiered' ? <Tag color="blue">梯度收费</Tag> : <Tag>固定收费</Tag> },
    { title: '周期', dataIndex: 'accrual_period', render: (v: string) => ({ NONE: '无', DAY: '按天', MONTH: '按月' } as any)[v] || '-' },
    { title: '梯度维度', dataIndex: 'tier_basis', render: (v: string) => tierBasisLabel(v) || '-' },
    { title: '展示单位', dataIndex: 'unit_label', render: (v: string) => v || '-' },
    { title: '区间最小', dataIndex: 'min_value' },
    { title: '区间最大', dataIndex: 'max_value' },
    { title: '单价', dataIndex: 'unit_price', render: (_: any, record: any) => {
      if (record?.rule_type === 'tiered') {
        // 物化规则通常没有 tiers_preview，回退到 tiers 计算范围
        const src = Array.isArray(record?.tiers_preview)
          ? record.tiers_preview
          : (Array.isArray(record?.tiers) ? record.tiers : []);
        const prices = src
          .map((t: any) => (t?.unit_price != null ? Number(t.unit_price) : null))
          .filter((n: any) => typeof n === 'number') as number[];
        if (prices.length > 0) {
          const min = Math.min(...prices).toFixed(2);
          const max = Math.max(...prices).toFixed(2);
          return `${min} - ${max}`;
        }
        // 与"最终生效规则"一致：屏蔽时不显示"查看梯度"，统一用"-"；
        // 非屏蔽时也保持一致性，无法计算范围即显示"-"。
        return '-';
      }
      return record?.unit_price != null ? Number(record.unit_price).toFixed(2) : '-';
    } },
    { title: '状态', dataIndex: 'is_active', render: (v: boolean, r: any) => {
      if (r?.is_masked && v) return <Tag color="red">屏蔽</Tag>;
      if (v) return <Tag color="green">启用</Tag>;
      return <Tag style={{ color: '#cf1322', background: '#fff1f0', borderColor: '#ffa39e' }}>禁用</Tag>;
    } },
    {
      title: '客户后台',
      dataIndex: 'visible_in_customer_portal',
      render: (v: boolean) => (v !== false ? <Tag color="blue">可见</Tag> : <Tag>隐藏(仅生效)</Tag>),
    },
    { title: '备注', dataIndex: 'remark', render: (v: string) => (v || '-'), width: 260 },
    {
      title: '操作',
      render: (_: any, record: any) => {
        const localLevel = scopeLevel;
        const items: any[] = [
          {
            key: 'edit',
            label: <span onClick={() => {
              setEditingRule(record);
              const ef = record.effective_from ? dayjs(record.effective_from) : null;
              const et = record.effective_to ? dayjs(record.effective_to) : null;
              ruleForm.setFieldsValue({
                ...record,
                operation_type: record.operation_type,
                rule_type: record.rule_type || 'flat',
                accrual_period: record.accrual_period || 'NONE',
                tier_basis: record.tier_basis || 'QUANTITY',
                pricing_basis: record.pricing_basis || record.tier_basis || 'QUANTITY',
                quantity_basis: record.quantity_basis || record.tier_basis || 'QUANTITY',
                visible_in_customer_portal: record.visible_in_customer_portal !== false,
                effective_from: ef,
                effective_to: et,
              });
              setModalLevel(record.rule_level || 'customer');
              setVisibleRuleModal(true);
            }}>编辑</span>
          },
          ...(record.rule_type === 'tiered' ? [{ key: 'tier', label: <span onClick={() => openTierEditor(record)}>编辑梯度</span> }] : []),
        ];
        return (
          <Dropdown menu={{ items }} trigger={['click']}>
            <Button size="small">操作</Button>
          </Dropdown>
        );
      }
    }
  ];

  // 本层物化规则列：与"最终生效规则"一致（定义位置需在 columnsEffective 之后）

  // 只读版本（客户级/项目级页面展示用）
  const columnsOpReadonly = [
    { title: '系统编码', dataIndex: 'system_code' },
    { title: '名称', dataIndex: 'name' },
    { title: '类别', dataIndex: 'category' },
    { title: '启用', dataIndex: 'is_active', render: (v: boolean) => (v ? '是' : '否') },
  ];

  // 汇总卡片只读列：含级别/适用客户/适用项目
  const columnsOpSummary = [
    { title: '系统编码', dataIndex: 'system_code' },
    { title: '序号', dataIndex: 'order_index' },
    { title: '名称', dataIndex: 'name' },
    { title: '类别', dataIndex: 'category' },
    {
      title: '作用域',
      render: (_: any, record: any) => {
        const u = opUsage[record.id];
        // 若后端返回 scopes，则以 scopes 为准；否则回退到使用统计
        const scopes = Array.isArray(record.scopes) ? record.scopes : [];
        const levels = new Set<string>();
        scopes.forEach((s: any) => levels.add(s.scope_level));
        if (levels.size === 0 && u) {
          if (u.system) levels.add('system');
          if ((u.customers || []).length > 0) levels.add('customer');
          if ((u.projects || []).length > 0) levels.add('project');
        }
        const order = ['system', 'customer', 'project'];
        const labelMap: any = { system: '系统', customer: '客户', project: '项目' };
        const list = order.filter(l => levels.has(l));
        return list.length ? (
          <Space size={4}>{list.map(l => <Tag key={l}>{labelMap[l]}</Tag>)}</Space>
        ) : <Tag>系统</Tag>;
      }
    },
    {
      title: '适用客户',
      render: (_: any, record: any) => {
        // 优先使用 scopes，直接显示数据库中声明的作用域
        const scopes = Array.isArray(record.scopes) ? record.scopes : [];
        const idSet = new Set<number>();
        scopes.forEach((s: any) => {
          if ((s.scope_level === 'customer' || s.scope_level === 'project') && s.customer_id) {
            idSet.add(Number(s.customer_id));
          }
        });
        const ids = Array.from(idSet);
        // 回退到统计
        const fallback = opUsage[record.id]?.customers || [];
        const finalIds = ids.length ? ids : fallback;
        if (!finalIds.length) return '-';
        const names = finalIds.map(id => customerMap[id] || String(id));
        const shown = names.slice(0, 6);
        const extra = names.length > 6 ? ` 等${names.length}个` : '';
        return <span title={names.join('、')}>{shown.join('、')}{extra}</span>;
      }
    },
    {
      title: '适用项目',
      render: (_: any, record: any) => {
        const scopes = Array.isArray(record.scopes) ? record.scopes : [];
        const pidSet = new Set<number>();
        scopes.forEach((s: any) => {
          if (s.scope_level === 'project' && s.project_id) {
            pidSet.add(Number(s.project_id));
          }
        });
        const pidsFromScopes = Array.from(pidSet);
        const fallback = opUsage[record.id]?.projects || [];
        const pids = pidsFromScopes.length ? pidsFromScopes : fallback;
        if (!pids.length) return '-';
        const labels = pids.map((pid) => projectMap[pid] || String(pid));
        const shown = labels.slice(0, 8);
        const extra = pids.length > 8 ? ` 等${pids.length}个` : '';
        return <span title={labels.join('、')}>{shown.join('、')}{extra}</span>;
      }
    },
    { title: '启用', dataIndex: 'is_active', render: (v: boolean) => (v ? <Tag color="green">启用</Tag> : <Tag style={{ color: '#cf1322', background: '#fff1f0', borderColor: '#ffa39e' }}>禁用</Tag>) },
  ];

  const columnsRule = [
    { title: '操作类型', dataIndex: 'operation_type_name' },
    { title: '类型', dataIndex: 'rule_type', render: (v: string) => v === 'tiered' ? <Tag color="blue">梯度收费</Tag> : <Tag>固定收费</Tag> },
    { title: '周期', dataIndex: 'accrual_period', render: (v: string) => ({ NONE: '无', DAY: '按天', MONTH: '按月' } as any)[v] || '-' },
  { title: '梯度维度', dataIndex: 'tier_basis', render: (v: string) => tierBasisLabel(v) || '-' },
    { title: '计费单位', dataIndex: 'billing_unit' },
    { title: '展示单位', dataIndex: 'unit_label', render: (v: string) => v || '-' },
    { title: (<span>屏蔽继承 <Tooltip title="本层显式阻断从上层（系统/客户）回退继承同一业务键的规则；屏蔽后若本层无规则，则最终生效为空。"><QuestionCircleOutlined style={{ marginLeft: 4 }} /></Tooltip></span>), dataIndex: 'is_masked', render: (v: boolean) => v ? <Tag color="red">已屏蔽</Tag> : <Tag color="green">未屏蔽</Tag> },
    { title: '区间最小', dataIndex: 'min_value' },
    { title: '区间最大', dataIndex: 'max_value' },
    { title: '单价', dataIndex: 'unit_price', render: (_: any, record: any) => {
      if (record?.rule_type === 'tiered' && Array.isArray(record?.tiers) && record.tiers.length > 0) {
        const prices = record.tiers
          .map((t: any) => (t?.unit_price != null ? Number(t.unit_price) : null))
          .filter((n: any) => typeof n === 'number') as number[];
        if (prices.length > 0) {
          const min = Math.min(...prices).toFixed(2);
          const max = Math.max(...prices).toFixed(2);
          return `${min} - ${max}`;
        }
      }
      return record?.unit_price != null ? Number(record.unit_price).toFixed(2) : '-';
    } },
    { title: '币种', dataIndex: 'currency' },
    { title: '生效', dataIndex: 'effective_from' },
    { title: '失效', dataIndex: 'effective_to' },
    { title: '启用', dataIndex: 'is_active', render: (v: boolean) => (v ? <Tag color="green">启用</Tag> : <Tag style={{ color: '#cf1322', background: '#fff1f0', borderColor: '#ffa39e' }}>禁用</Tag>) },
    {
      title: '客户后台',
      dataIndex: 'visible_in_customer_portal',
      render: (v: boolean) => (v !== false ? <Tag color="blue">可见</Tag> : <Tag>隐藏(仅生效)</Tag>),
    },
    { title: '备注', dataIndex: 'remark', render: (v: string) => v || '-' },
    {
      title: '操作',
      render: (_: any, record: any) => {
        const items: any[] = [
          {
            key: 'edit',
            label: <span onClick={() => {
              setEditingRule(record);
              const ef = record.effective_from ? dayjs(record.effective_from) : null;
              const et = record.effective_to ? dayjs(record.effective_to) : null;
              ruleForm.setFieldsValue({
                ...record,
                operation_type: record.operation_type,
                rule_type: record.rule_type || 'flat',
                accrual_period: record.accrual_period || 'NONE',
                tier_basis: record.tier_basis || 'QUANTITY',
                pricing_basis: record.pricing_basis || record.tier_basis || 'QUANTITY',
                quantity_basis: record.quantity_basis || record.tier_basis || 'QUANTITY',
                visible_in_customer_portal: record.visible_in_customer_portal !== false,
                effective_from: ef,
                effective_to: et,
              });
              setModalLevel(record.rule_level || 'system');
              setVisibleRuleModal(true);
            }}>编辑</span>
          },
          ...(record.rule_type === 'tiered' ? [{ key: 'tier', label: <span onClick={() => openTierEditor(record)}>编辑梯度</span> }] : []),
          // 仅当当前设置级别与规则来源级别一致，且未屏蔽时显示"展示配置"
          ...(((record?.rule_level || (record?.source_level ?? '')) === scopeLevel) && !record?.is_masked
            ? [{ key: 'present', label: <span onClick={() => openRulePresentation(record)}>展示配置</span> }]
            : []),
          ...(scopeLevel !== 'system' ? [
            { key: 'suppress', label: <span onClick={() => suppressRule(record)}>屏蔽</span> },
            { key: 'reset', label: <span onClick={() => resetOverride(record)}>恢复继承</span> },
          ] : []),
          ...(record.rule_level === 'system' ? [
            { key: 'toggle', label: <span onClick={async () => {
              setLoading(true);
              try {
                await request.put(`/api/v1/billing/billing-rules/${record.id}/`, {
                  rule_level: 'system',
                  operation_type: record.operation_type,
                  billing_unit: record.billing_unit,
                  rule_type: record.rule_type,
                  tier_basis: record.tier_basis,
                  pricing_basis: record.pricing_basis || record.tier_basis,
                  quantity_basis: record.quantity_basis || record.tier_basis,
                  accrual_period: record.accrual_period,
                  min_value: record.min_value,
                  max_value: record.max_value,
                  unit_price: record.unit_price,
                  currency: record.currency,
                  effective_from: record.effective_from,
                  effective_to: record.effective_to,
                  is_active: !record.is_active,
                  is_masked: record.is_masked,
                });
                message.success(record.is_active ? '已禁用' : '已启用');
                await fetchSystemRulesOnly();
              } finally { setLoading(false); }
            }}>{record.is_active ? '禁用' : '启用'}</span> },
            { key: 'delete', label: <span style={{ color: '#ff4d4f' }} onClick={() => {
              Modal.confirm({
                title: '确认删除该系统级规则？',
                onOk: async () => {
                  setLoading(true);
                  try {
                    await request.delete(`/api/v1/billing/billing-rules/${record.id}/`);
                    message.success('系统级规则已删除');
                    await fetchSystemRulesOnly();
                  } finally { setLoading(false); }
                }
              });
            }}>删除</span> }
          ] : []),
        ];
        return (
          <Dropdown menu={{ items }} trigger={['click']}>
            <Button size="small">操作</Button>
          </Dropdown>
        );
      }
    }
  ];

  // 系统级规则表专用列：移除"币种/生效/失效"并调整列宽
  const columnsRuleSystem = React.useMemo(() => {
    const filtered = (columnsRule as any[]).filter((c) => !['币种', '生效', '失效', '计费单位'].includes((c as any).title));
    return filtered.map((c) => {
      if ((c as any).title === '周期') {
        return {
          ...c,
          render: (v: string) => (v === 'DAY' ? '按天' : (v === 'MONTH' ? '按月' : '-')),
        };
      }
      if ((c as any).title === '备注') {
        return { ...c, width: 260 };
      }
      if ((c as any).title === '操作') {
        return { ...c, width: 180 };
      }
      return c;
    });
  }, [columnsRule]);

  const columnsEffective = [
    { title: '系统编码', dataIndex: 'system_code' },
    { title: '操作类型', dataIndex: 'operation_type_name' },
    { title: '类型', dataIndex: 'rule_type', render: (v: string) => v === 'tiered' ? <Tag color="blue">梯度收费</Tag> : <Tag>固定收费</Tag> },
    { title: '周期', dataIndex: 'accrual_period', render: (v: string) => (v === 'DAY' ? '按天' : (v === 'MONTH' ? '按月' : '-')) },
    { title: '梯度维度', dataIndex: 'tier_basis', render: (v: string) => tierBasisLabel(v) || '-' },
    { title: '展示单位', dataIndex: 'unit_label', render: (v: string) => v || '-' },
    { title: '区间最小', dataIndex: 'min_value' },
    { title: '区间最大', dataIndex: 'max_value' },
    { title: '单价', dataIndex: 'unit_price', render: (_: any, record: any) => {
      if (record?.rule_type === 'tiered') {
        // 优先使用 effective 返回的预计算范围
        if (record?.unit_price_display) return record.unit_price_display;
        // 回退：从 tiers_preview 或 tiers 计算范围
        const src = Array.isArray(record?.tiers_preview)
          ? record.tiers_preview
          : (Array.isArray(record?.tiers) ? record.tiers : []);
        const prices = src
          .map((t: any) => (t?.unit_price != null ? Number(t.unit_price) : null))
          .filter((n: any) => typeof n === 'number') as number[];
        if (prices.length > 0) {
          const min = Math.min(...prices).toFixed(2);
          const max = Math.max(...prices).toFixed(2);
          return `${min} - ${max}`;
        }
        return '查看梯度';
      }
      return record?.unit_price != null ? Number(record.unit_price).toFixed(2) : '-';
    } },
    // 为与系统级规则列表一致，移除"币种/生效/失效"列
    // { title: '币种', dataIndex: 'currency' },
    // { title: '生效', dataIndex: 'effective_from' },
    // { title: '失效', dataIndex: 'effective_to' },
    { title: (
      <span>
        状态
        <Tooltip title="未屏蔽且启用=参与计费；已屏蔽且启用=屏蔽生效（阻断回退，不计费）；禁用=该记录不生效/屏蔽关闭。">
          <QuestionCircleOutlined style={{ marginLeft: 6, color: '#999' }} />
        </Tooltip>
      </span>
    ), dataIndex: 'is_active', render: (v: boolean, r: any) => {
      if (r?.is_masked && v) return <Tag color="red">屏蔽</Tag>;
      if (v) return <Tag color="green">启用</Tag>;
      return <Tag style={{ color: '#cf1322', background: '#fff1f0', borderColor: '#ffa39e' }}>禁用</Tag>;
    } },
    { title: '备注', dataIndex: 'rule_remark', render: (v: string) => (v || '-'), width: 260 },
    {
      title: '操作',
      render: (_: any, record: any) => {
        const isCustomer = scopeLevel === 'customer';
        const isProject = scopeLevel === 'project';
        const localLevel = isProject ? 'project' : (isCustomer ? 'customer' : 'system');
        const isLocal = (record?.rule_level === localLevel) || ((record?.source_level ?? record?.rule_level) === localLevel);
        const isCovered = isLocal && !!record?.inherited_from_rule && !record?.is_masked;
        const isMasked = !!record?.is_masked;
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <Space>
              {scopeLevel !== 'system' && (
                <Tooltip title={isCovered ? '已在本层覆盖，点击可再次修改' : '在本层生成可编辑规则；梯度将直接进入梯度编辑'}>
                  <Button size="small"
                          style={isCovered ? { background: '#f5f0ff', borderColor: '#d3adf7' } : undefined}
                          onClick={() => {
                            // 覆盖前校验作用域选择
                            if (scopeLevel === 'customer' && !scopeCustomerId) {
                              message.warning('请先选择客户再执行覆盖');
                              return;
                            }
                            if (scopeLevel === 'project' && (!scopeCustomerId || !scopeProjectId)) {
                              message.warning('请先选择客户与项目再执行覆盖');
                              return;
                            }
                            if (record?.rule_type === 'tiered') {
                              coverAndEditTier(record);
                              return;
                            }
                            // 已覆盖：进入编辑（PUT），未覆盖：创建（POST）
                            try { setModalLevel(scopeLevel); } catch {}
                            try { ruleForm.resetFields(); } catch {}
                            if (isCovered) {
                              // 编辑本层已有规则
                              setEditingRule(record);
                              ruleForm.setFieldsValue({
                                operation_type: record.operation_type,
                                billing_unit: record.billing_unit,
                                min_value: record.min_value,
                                max_value: record.max_value,
                                unit_price: record.unit_price,
                                currency: record.currency,
                                unit_label: record.unit_label,
                                remark: record.rule_remark || record.remark,
                                effective_from: record.effective_from ? dayjs(record.effective_from) : undefined,
                                effective_to: record.effective_to ? dayjs(record.effective_to) : undefined,
                                rule_type: record.rule_type || 'flat',
                                accrual_period: record.accrual_period || 'NONE',
                                tier_basis: record.tier_basis || 'QUANTITY',
                                pricing_basis: record.pricing_basis || record.tier_basis || 'QUANTITY',
                                quantity_basis: record.quantity_basis || record.tier_basis || 'QUANTITY',
                                variant_key: (record.variant_key === undefined || record.variant_key === '' || String(record.variant_key).toLowerCase() === 'null') ? null : record.variant_key,
                                is_active: record.is_active !== false,
                                visible_in_customer_portal: record.visible_in_customer_portal !== false,
                              });
                              setVisibleRuleModal(true);
                            } else {
                              // 首次覆盖：创建本层规则
                              setEditingRule({ ...record, id: undefined, inherited_from_rule: record.id });
                              ruleForm.setFieldsValue({
                                operation_type: record.operation_type,
                                billing_unit: record.billing_unit,
                                min_value: record.min_value,
                                max_value: record.max_value,
                                unit_price: record.unit_price,
                                currency: record.currency,
                                unit_label: record.unit_label,
                                remark: record.rule_remark || record.remark,
                                effective_from: record.effective_from ? dayjs(record.effective_from) : undefined,
                                effective_to: record.effective_to ? dayjs(record.effective_to) : undefined,
                                rule_type: record.rule_type || 'flat',
                                accrual_period: record.accrual_period || 'NONE',
                                tier_basis: record.tier_basis || 'QUANTITY',
                                pricing_basis: record.pricing_basis || record.tier_basis || 'QUANTITY',
                                quantity_basis: record.quantity_basis || record.tier_basis || 'QUANTITY',
                                variant_key: (record.variant_key === undefined || record.variant_key === '' || String(record.variant_key).toLowerCase() === 'null') ? null : record.variant_key,
                                is_active: true,
                                visible_in_customer_portal: record.visible_in_customer_portal !== false,
                              });
                              setVisibleRuleModal(true);
                            }
                          }}>
                    {isCovered ? '已覆盖' : '覆盖'}
                  </Button>
                </Tooltip>
              )}
              {((record?.rule_level || (record?.source_level ?? '')) === localLevel) && !isMasked && (
                <Button size="small" onClick={() => openRulePresentation(record)}>展示配置</Button>
              )}
            </Space>
            {scopeLevel !== 'system' && (
              <Space>
                <Tooltip title={isMasked ? '屏蔽已生效：阻断回退，若本层无规则则不收费' : '本层阻断继承：同键不再回退到上层；如本层无规则则最终不收费'}>
                  <Button size="small" danger={true}
                          disabled={isMasked}
                          style={isMasked ? { background: '#fff1f0', borderColor: '#ffccc7', color: '#cf1322' } : undefined}
                          onClick={() => { if (!isMasked) suppressRule(record); }}>
                    {isMasked ? '已屏蔽' : '屏蔽'}
                  </Button>
                </Tooltip>
                <Tooltip title="取消本层屏蔽/覆盖，恢复从上层回退">
                  <Button size="small" onClick={() => resetOverride(record)}>恢复继承</Button>
                </Tooltip>
              </Space>
            )}
          </div>
        );
      }
    }
  ].filter(Boolean as any);

  const saveOpType = async () => {
    const values = await opForm.validateFields();
    const payload: any = { ...values };
    // UniqueTogetherValidator 要求唯一键字段显式提供；undefined/空串均转为 null
    if (!('variant_key' in payload) || payload.variant_key === undefined || payload.variant_key === '' || String(payload.variant_key).toLowerCase() === 'null') {
      payload.variant_key = null;
    }
    // 覆盖时确保关键字段完整（尤其是项目级）：
    if (!payload.currency) {
      payload.currency = editingRule?.currency || 'USD';
    }
    // 将当前上下文的客户/项目写入，用于创建 OperationTypeScope
    const level = payload.scope_level || modalOpScope;
    if (level === 'customer') {
      payload.customer_id = scopeCustomerId;
      payload.project_id = null;
    }
    if (level === 'project') {
      payload.customer_id = scopeCustomerId;
      payload.project_id = scopeProjectId;
    }
    setLoading(true);
    try {
      if (editingOp?.id) {
        await request.put(`/api/v1/billing/operation-types/${editingOp.id}/`, payload);
      } else {
        await request.post(`/api/v1/billing/operation-types/`, payload);
      }
      message.success('操作类型已保存');
      setVisibleOpModal(false);
      setEditingOp(null);
      await fetchOpTypes();
      await buildOpTypeUsageSummary();
    } finally {
      setLoading(false);
    }
  };

  const saveRule = async () => {
    const values = await ruleForm.validateFields();
    const payload: any = { ...values };
    if (!payload.pricing_basis) {
      payload.pricing_basis = payload.tier_basis || 'QUANTITY';
    }
    if (!payload.quantity_basis) {
      payload.quantity_basis = payload.tier_basis || 'QUANTITY';
    }
    payload.rule_level = modalLevel || (scopeLevel === 'system' ? 'system' : scopeLevel);
    if (payload.rule_level === 'customer') {
      payload.customer_id = scopeCustomerId;
      payload.project_id = null;
    }
    if (payload.rule_level === 'project') {
      payload.customer_id = scopeCustomerId;
      payload.project_id = scopeProjectId;
    }
    // 覆盖来源：从编辑态保留下来的来源ID（仅创建时使用）
    if (!editingRule?.id && editingRule?.inherited_from_rule) {
      payload.inherited_from_rule = editingRule.inherited_from_rule;
    }
    if (!('variant_key' in payload) || payload.variant_key === undefined || payload.variant_key === '') {
      payload.variant_key = null;
    }
    if (values?.effective_from && (values.effective_from as any).format) {
      payload.effective_from = (values.effective_from as any).format('YYYY-MM-DD');
    }
    if (values?.effective_to && (values.effective_to as any).format) {
      payload.effective_to = (values.effective_to as any).format('YYYY-MM-DD');
    }
    setLoading(true);
    try {
      setRuleSaveDebug({ when: 'before', payload });
      if (editingRule?.id) {
        await request.put(`/api/v1/billing/billing-rules/${editingRule.id}/`, payload);
      } else {
        const res = await request.post(`/api/v1/billing/billing-rules/`, payload);
        setRuleSaveDebug({ when: 'after', payload, response: res?.data ?? res });
      }
      message.success('收费规则已保存');
      setVisibleRuleModal(false);
      setEditingRule(null);
      await fetchRulesByScope();
      // 若当前在系统级页，刷新系统级规则便于立刻看到新增项
      if (activeTab === 'system-rules') {
        await fetchSystemRulesOnly();
      }
    } finally {
      setLoading(false);
    }
  };

  // 梯度编辑
  const [tierModalOpen, setTierModalOpen] = React.useState(false);
  const [tierRule, setTierRule] = React.useState<any | null>(null);
  const [tiers, setTiers] = React.useState<Array<any>>([]);
  const [tierLoading, setTierLoading] = React.useState(false);

  const openTierEditor = async (rule: any) => {
    setTierRule(rule);
    setTierModalOpen(true);
    setTierLoading(true);
    try {
      const res = await request.get(`/api/v1/billing/billing-rules/${rule.id}/tiers/`);
      setTiers(res.data || []);
    } finally {
      setTierLoading(false);
    }
  };

  const addTierRow = () => {
    setTiers(prev => [...prev, { id: undefined, min_value: null, max_value: null, unit_price: 0 }]);
  };

  const saveAllTiers = async () => {
    if (!tierRule) return;
    setTierLoading(true);
    try {
      const saved: any[] = [];
      for (const row of tiers) {
        if (row.id) {
          const res = await request.put(`/api/v1/billing/billing-rules/${tierRule.id}/tiers/${row.id}/`, row);
          saved.push(res.data);
        } else {
          const res = await request.post(`/api/v1/billing/billing-rules/${tierRule.id}/tiers/`, row);
          saved.push(res.data);
        }
      }
      setTiers(saved);
      message.success('已保存全部梯度');
      // 关闭编辑弹窗并刷新规则列表
      try { setTierModalOpen(false); } catch {}
      try { await fetchRulesByScope(); } catch {}
    } finally {
      setTierLoading(false);
    }
  };

  const saveTierRow = async (index: number) => {
    if (!tierRule) return;
    const row = tiers[index];
    setTierLoading(true);
    try {
      if (row.id) {
        const res = await request.put(`/api/v1/billing/billing-rules/${tierRule.id}/tiers/${row.id}/`, row);
        const next = [...tiers];
        next[index] = res.data;
        setTiers(next);
      } else {
        const res = await request.post(`/api/v1/billing/billing-rules/${tierRule.id}/tiers/`, row);
        const next = [...tiers];
        next[index] = res.data;
        setTiers(next);
      }
      message.success('梯度已保存');
      // 单行保存后刷新"最终生效规则"，但不关闭弹窗
      try { await fetchRulesByScope(); } catch {}
    } finally {
      setTierLoading(false);
    }
  };

  // 覆盖并编辑梯度：若生效规则不在本层，先物化一条本层规则并复制梯度，再打开梯度编辑器
  const coverAndEditTier = async (record: any) => {
    // 判断是否已是本层规则
    const isCustomerLayer = scopeLevel === 'customer';
    const isProjectLayer = scopeLevel === 'project';
    const isLocal = (isCustomerLayer && record.rule_level === 'customer') || (isProjectLayer && record.rule_level === 'project');
    let targetRule = record;
    if (!isLocal) {
      // 物化一条本层规则
      const payload: any = {
        rule_level: scopeLevel,
        customer_id: scopeCustomerId,
        project_id: isProjectLayer ? scopeProjectId : null,
        operation_type: record.operation_type,
        billing_unit: record.billing_unit,
        rule_type: record.rule_type,
        tier_basis: record.tier_basis,
        variant_key: (record.variant_key === undefined || record.variant_key === '' || String(record.variant_key).toLowerCase() === 'null') ? null : record.variant_key,
        min_value: record.min_value ?? null,
        max_value: record.max_value ?? null,
        unit_price: record.unit_price ?? 0,
        unit_label: record.unit_label || null,
        remark: record.rule_remark || record.remark || null,
        currency: record.currency || 'USD',
        effective_from: record.effective_from,
        effective_to: record.effective_to,
        is_active: true,
        inherited_from_rule: record.id,
      };
      setLoading(true);
      try {
        const res = await request.post('/api/v1/billing/billing-rules/', payload);
        targetRule = res.data || res;
        // 复制源梯度到目标（若为梯度收费）
        if (record.rule_type === 'tiered') {
          try {
            const list = await request.get(`/api/v1/billing/billing-rules/${record.id}/tiers/`, { params: { locale: previewLocale } });
            const tiersSrc = Array.isArray(list.data) ? list.data : [];
            for (const t of tiersSrc) {
              await request.post(`/api/v1/billing/billing-rules/${targetRule.id}/tiers/`, {
                min_value: t.min_value ?? null,
                max_value: t.max_value ?? null,
                unit_price: t.unit_price,
              });
            }
          } catch {
            // ignore tier copy errors
          }
        }
      } finally {
        setLoading(false);
      }
      // 刷新本层规则与生效规则
      await fetchRulesByScope();
    }
    // 打开梯度编辑器
    openTierEditor(targetRule);
  };

  const deleteTierRow = async (index: number) => {
    if (!tierRule) return;
    const row = tiers[index];
    if (!row.id) {
      setTiers(prev => prev.filter((_, i) => i !== index));
      return;
    }
    setTierLoading(true);
    try {
      await request.delete(`/api/v1/billing/billing-rules/${tierRule.id}/tiers/${row.id}/`);
      setTiers(prev => prev.filter((_, i) => i !== index));
      message.success('已删除梯度');
    } finally {
      setTierLoading(false);
    }
  };

  const suppressRule = async (record: any) => {
    const body: any = {
      rule_level: scopeLevel,
      customer_id: scopeCustomerId,
      project_id: scopeProjectId,
      operation_type: record.operation_type,
      billing_unit: record.billing_unit,
      min_value: record.min_value,
      max_value: record.max_value,
      // 精确匹配同一条规则：传递 currency 与 variant_key
      currency: record.currency,
      variant_key: record.variant_key ?? null,
    };
    await request.post('/api/v1/billing/billing-rules/suppress/', body);
    message.success('已屏蔽该规则');
    fetchRulesByScope();
  };

  const resetOverride = async (record: any) => {
    // 归一化变体键：''/'null'/undefined -> null
    const normVariant = (v: any) => {
      if (v === undefined || v === null) return null;
      const s = String(v).trim();
      if (s === '' || s.toLowerCase() === 'null') return null;
      return v;
    };
    const body: any = {
      rule_level: scopeLevel,
      customer_id: scopeCustomerId,
      project_id: scopeProjectId,
      operation_type: record.operation_type,
      billing_unit: record.billing_unit,
      min_value: record.min_value,
      max_value: record.max_value,
      currency: record.currency,
      variant_key: normVariant(record.variant_key),
    };
    setLoading(true);
    try {
      await request.post('/api/v1/billing/billing-rules/reset_override/', body);
      // 前端兜底清理：删除当前层同业务键的物化覆盖记录
      try {
        const params: any = {
          rule_level: scopeLevel,
          customer_id: scopeCustomerId,
          project_id: scopeProjectId,
          operation_type: record.operation_type,
          billing_unit: record.billing_unit,
          currency: record.currency,
          min_value: record.min_value,
          max_value: record.max_value,
          variant_key: normVariant(record.variant_key),
          all: 1,
        };
        const listRes = await request.get('/api/v1/billing/billing-rules/', { params });
        const list = listRes.data?.results || listRes.data || [];
        let deleted = 0;
        for (const r of list) {
          const sameKey =
            Number(r.operation_type) === Number(record.operation_type) &&
            String(r.billing_unit) === String(record.billing_unit) &&
            ((r.min_value ?? null) === (record.min_value ?? null)) &&
            ((r.max_value ?? null) === (record.max_value ?? null)) &&
            String(r.currency || '') === String(record.currency || '') &&
            ((r.variant_key ?? null) === normVariant(record.variant_key));
          const isLocalLevel = (r.rule_level === scopeLevel);
          const isOverrideLike = !!r.inherited_from_rule || isLocalLevel; // 保守：本层同键视为可清理
          if (isLocalLevel && sameKey && isOverrideLike) {
            try { await request.delete(`/api/v1/billing/billing-rules/${r.id}/`); deleted += 1; } catch {}
          }
        }
        message.success(deleted > 0 ? `已恢复继承并清理本层覆盖 ${deleted} 条` : '已恢复继承');
      } catch {
        message.success('已恢复继承');
      }
      await fetchRulesByScope();
    } finally {
      setLoading(false);
    }
  };

  const applyToCustomer = async (customerId: number, overwrite: boolean) => {
    setLoading(true);
    try {
      const res = await request.post(`/api/v1/billing/billing-rules/apply_to_customer/`, { customer_id: customerId, overwrite });
      message.success(`已下发到客户：新增${res.data?.created || 0}，更新${res.data?.updated || 0}`);
    } finally {
      setLoading(false);
    }
  };

  const applyToProject = async (customerId: number, projectId: number, overwrite: boolean) => {
    setLoading(true);
    try {
      const res = await request.post(`/api/v1/billing/billing-rules/apply_to_project/`, { customer_id: customerId, project_id: projectId, overwrite });
      message.success(`已下发到项目：新增${res.data?.created || 0}，更新${res.data?.updated || 0}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">收费系统</h1>
      </div>

      <Tabs type="card" activeKey={activeTab} onChange={(k) => { setActiveTab(k); if (k === 'system-rules') { setScopeLevel('system'); fetchOpTypes(); buildOpTypeUsageSummary(); fetchSystemRulesOnly(); } else if (k === 'customer-settings') { setScopeLevel('customer'); setScopeProjectId(undefined); setProjectOptions([]); setRules([]); setEffectiveRules([]); setScopedDebug(null); } else if (k === 'project-settings') { setScopeLevel('project'); setScopeProjectId(undefined); setProjectOptions([]); setRules([]); setEffectiveRules([]); setScopedDebug(null); } else if (k === 'op-types') { buildOpTypeUsageSummary(); } else if (k === 'rule-summary') { fetchRuleSummary(); } }}>
        <TabPane tab="操作类型字典汇总" key="op-types">
          <Alert
            type="info"
            showIcon
            message="使用说明（只读）"
            description={(
              <div>
                <div>· 此处仅展示所有已定义的操作类型字典及其使用级别与适用范围。</div>
                <div>· 如需新增/编辑/禁用操作类型，请前往对应级别卡片（系统级设置/客户级设置/项目级设置）。</div>
              </div>
            )}
            className="mb-3"
          />
          <div className="mb-3 flex items-center gap-2">
            <Input.Search
              allowClear
              placeholder="搜索关键字（名称/编码/描述）"
              style={{ width: 260 }}
              value={summaryKeyword}
              onChange={(e) => setSummaryKeyword(e.target.value)}
              onSearch={(v) => setSummaryKeyword(v)}
            />
            <Select
              value={summaryFilterLevel}
              onChange={(v) => setSummaryFilterLevel(v)}
              options={[
                { value: 'all', label: '全部作用域' },
                { value: 'system', label: '仅系统级' },
                { value: 'customer', label: '仅客户级' },
                { value: 'project', label: '仅项目级' },
              ]}
              style={{ width: 140 }}
            />
            <Select
              allowClear
              placeholder="筛选类别（可选）"
              style={{ width: 180 }}
              value={summaryCategory}
              onChange={(v) => setSummaryCategory(v as string | undefined)}
              options={[
                { value: 'INBOUND', label: '入库' },
                { value: 'INVENTORY_MANAGEMENT', label: '在库管理' },
                { value: 'OUTBOUND', label: '出库' },
                { value: 'VALUE_ADDED', label: '增值服务' },
                { value: 'ADJUSTMENT', label: '调整' },
              ]}
            />
            <Select
              placeholder="筛选客户（可选）"
              allowClear
              showSearch
              style={{ width: 260 }}
              options={customerOptions}
              onFocus={ensureCustomersLoaded}
              optionFilterProp="label"
              value={summaryFilterCustomerId}
              onChange={(v) => { setSummaryFilterCustomerId(v as number | undefined); setSummaryFilterProjectId(undefined); setSummaryProjectOptions([]); }}
            />
            <Select
              placeholder={summaryFilterCustomerId ? '筛选项目（可选）' : '先选择客户'}
              allowClear
              showSearch
              disabled={!summaryFilterCustomerId}
              style={{ width: 300 }}
              loading={summaryProjectLoading}
              value={summaryFilterProjectId}
              onFocus={async () => { if (!summaryFilterCustomerId) return; setSummaryProjectLoading(true); try { const resp = await getProjectList({ page:1, page_size: 100, search:'', customer: summaryFilterCustomerId }); const results = Array.isArray((resp.data as any)?.results) ? (resp.data as any).results : []; setSummaryProjectOptions(results.map((p:any)=>({ value:Number(p.id), label:`${p.project_code || p.id} - ${p.name}`}))); } finally { setSummaryProjectLoading(false); } }}
              onSearch={async (val) => { if (!summaryFilterCustomerId) return; setSummaryProjectLoading(true); try { const resp = await getProjectList({ page:1, page_size: 100, search:val || '', customer: summaryFilterCustomerId }); const results = Array.isArray((resp.data as any)?.results) ? (resp.data as any).results : []; setSummaryProjectOptions(results.map((p:any)=>({ value:Number(p.id), label:`${p.project_code || p.id} - ${p.name}`}))); } finally { setSummaryProjectLoading(false); } }}
              filterOption={false}
              options={summaryProjectOptions}
              onChange={(v)=> setSummaryFilterProjectId(v as number | undefined)}
            />
            <Button onClick={() => { setSummaryKeyword(''); setSummaryCategory(undefined); setSummaryFilterLevel('all'); setSummaryFilterCustomerId(undefined); setSummaryFilterProjectId(undefined); setSummaryProjectOptions([]); setSummaryPage(1); }}>重置</Button>
          </div>
          <Table rowKey="id" loading={loading} dataSource={summaryFiltered}
            columns={columnsOpSummary}
            pagination={{ current: summaryPage, pageSize: summaryPageSize, total: summaryFiltered.length, showSizeChanger: true, pageSizeOptions: [10,20,50,100] as any, showTotal: (total, range) => `共${total}条，当前${range[0]}-${range[1]}条` }}
            onChange={(p)=>{ setSummaryPage(p.current || 1); setSummaryPageSize(p.pageSize || 20); }}
          />
        </TabPane>

        <TabPane tab="最终收费规则-只读" key="rule-summary">
          <Alert
            type="info"
            showIcon
            message="使用说明（只读）"
            description={(
              <div>
                <div>· 汇总展示系统级/客户级/项目级的收费规则，仅用于查看与筛选。</div>
                <div>· 如需新增/编辑/禁用收费规则，请前往后续三个级别设置页面。</div>
              </div>
            )}
            className="mb-3"
          />
          <div className="mb-3 flex items-center gap-2">
            <Select
              value={ruleSummaryFilterLevel}
              onChange={(v) => setRuleSummaryFilterLevel(v)}
              options={[
                { value: 'all', label: '全部级别' },
                { value: 'system', label: '系统级' },
                { value: 'customer', label: '客户级' },
                { value: 'project', label: '项目级' },
              ]}
              style={{ width: 140 }}
            />
            <Select
              value={ruleSummaryType}
              onChange={(v) => setRuleSummaryType(v as any)}
              options={[
                { value: 'all', label: '全部类型' },
                { value: 'flat', label: '固定收费' },
                { value: 'tiered', label: '梯度收费' },
              ]}
              style={{ width: 140 }}
            />
            <Select
              allowClear
              placeholder="筛选类别（可选）"
              style={{ width: 180 }}
              value={ruleSummaryCategory}
              onChange={(v) => setRuleSummaryCategory(v as string | undefined)}
              options={[
                { value: 'INBOUND', label: '入库' },
                { value: 'INVENTORY_MANAGEMENT', label: '在库管理' },
                { value: 'OUTBOUND', label: '出库' },
                { value: 'VALUE_ADDED', label: '增值服务' },
                { value: 'ADJUSTMENT', label: '调整' },
              ]}
            />
            <Select
              placeholder="筛选客户（可选）"
              allowClear
              showSearch
              style={{ width: 260 }}
              options={customerOptions}
              onFocus={ensureCustomersLoaded}
              optionFilterProp="label"
              value={ruleSummaryCustomerId}
              onChange={(v) => { setRuleSummaryCustomerId(v as number | undefined); setRuleSummaryProjectId(undefined); setRuleSummaryProjectOptions([]); }}
            />
            <Select
              placeholder={ruleSummaryCustomerId ? '筛选项目（可选）' : '先选择客户'}
              allowClear
              showSearch
              disabled={!ruleSummaryCustomerId}
              style={{ width: 300 }}
              loading={ruleSummaryProjectLoading}
              value={ruleSummaryProjectId}
              onFocus={async () => { if (!ruleSummaryCustomerId) return; setRuleSummaryProjectLoading(true); try { const resp = await getProjectList({ page:1, page_size: 100, search:'', customer: ruleSummaryCustomerId }); const results = Array.isArray((resp.data as any)?.results) ? (resp.data as any).results : []; setRuleSummaryProjectOptions(results.map((p:any)=>({ value:Number(p.id), label:`${p.project_code || p.id} - ${p.name}`}))); } finally { setRuleSummaryProjectLoading(false); } }}
              onSearch={async (val) => { if (!ruleSummaryCustomerId) return; setRuleSummaryProjectLoading(true); try { const resp = await getProjectList({ page:1, page_size: 100, search:val || '', customer: ruleSummaryCustomerId }); const results = Array.isArray((resp.data as any)?.results) ? (resp.data as any).results : []; setRuleSummaryProjectOptions(results.map((p:any)=>({ value:Number(p.id), label:`${p.project_code || p.id} - ${p.name}`}))); } finally { setRuleSummaryProjectLoading(false); } }}
              filterOption={false}
              options={ruleSummaryProjectOptions}
              onChange={(v)=> setRuleSummaryProjectId(v as number | undefined)}
            />
            <Button onClick={fetchRuleSummary}>刷新</Button>
            <Button onClick={() => { setRuleSummaryFilterLevel('all'); setRuleSummaryType('all'); setRuleSummaryCategory(undefined); setRuleSummaryCustomerId(undefined); setRuleSummaryProjectId(undefined); setRuleSummaryProjectOptions([]); setRuleSummaryPage(1); }}>重置</Button>
          </div>
          <Table
            rowKey={(r) => `${r.rule_level}-${r.id}`}
            loading={loading}
            dataSource={ruleSummaryFiltered}
            columns={[
              { title: '系统编码', dataIndex: 'system_code' },
              { title: '级别', dataIndex: 'rule_level', render: (v:string)=>(<Tag>{v}</Tag>) },
              { title: '客户', dataIndex: 'customer_name', render: (v: any, r: any) => v || r.customer_id || '-' },
              { title: '项目', dataIndex: 'project_code', render: (v: any, r: any) => v || r.project_id || '-' },
                { title: '操作类型', dataIndex: 'operation_type_name' },
              { title: '类型', dataIndex: 'rule_type', render: (v: string, record: any) => (
                v === 'tiered' ? (
                  <Tooltip title="点击查看梯度">
                    <Tag color="blue" onClick={() => openTierView(record)} style={{ cursor: 'pointer' }}>梯度收费</Tag>
                  </Tooltip>
                ) : <Tag>固定收费</Tag>
              ) },
              { title: '梯度维度', dataIndex: 'tier_basis', render: (v: string) => tierBasisLabel(v) },
              
              { title: '展示单位', dataIndex: 'unit_label', render: (v: string) => v || '-' },
              { title: (<span>区间<br/>最小</span>), dataIndex: 'min_value', width: 50 },
              { title: (<span>区间<br/>最大</span>), dataIndex: 'max_value', width: 50 },
              { title: '单价', dataIndex: 'unit_price', render: (_: any, record: any) => {
                if (record?.rule_type === 'tiered') {
                  // 已屏蔽的梯度规则不展示"查看梯度"，统一显示为"-"
                  if (record?.is_masked) return '-';
                  let display = '查看梯度';
                  if (Array.isArray(record?.tiers) && record.tiers.length > 0) {
                    const prices = record.tiers
                      .map((t: any) => (t?.unit_price != null ? Number(t.unit_price) : null))
                      .filter((n: any) => typeof n === 'number') as number[];
                    if (prices.length > 0) {
                      const min = Math.min(...prices).toFixed(2);
                      const max = Math.max(...prices).toFixed(2);
                      display = `${min} - ${max}`;
                    }
                  }
                  return (
                    <Tooltip title="点击查看梯度详情">
                      <span style={{ color: '#1677ff', cursor: 'pointer' }} onClick={() => openTierView(record)}>{display}</span>
                    </Tooltip>
                  );
                }
                return record?.unit_price != null ? Number(record.unit_price).toFixed(2) : '-';
              } },
              // 移除：币种/生效/失效
              { title: (
                <span>
                  状态
                  <Tooltip title="未屏蔽且启用=参与计费；已屏蔽且启用=屏蔽生效（阻断回退，不计费）；禁用=该记录不生效/屏蔽关闭。">
                    <QuestionCircleOutlined style={{ marginLeft: 6, color: '#999' }} />
                  </Tooltip>
                </span>
              ), dataIndex: 'is_active', render: (v: boolean, r: any) => {
                if (r?.is_masked && v) return <Tag color="red">屏蔽</Tag>;
                if (v) return <Tag color="green">启用</Tag>;
                return <Tag style={{ color: '#cf1322', background: '#fff1f0', borderColor: '#ffa39e' }}>禁用</Tag>;
              } },
              { title: '备注', dataIndex: 'remark', render: (v: string) => v || '-', width: 200 },
            ]}
            pagination={{ current: ruleSummaryPage, pageSize: ruleSummaryPageSize, total: ruleSummaryFiltered.length, showSizeChanger: true, pageSizeOptions: [10,20,50,100] as any, showTotal: (total, range) => `共${total}条，当前${range[0]}-${range[1]}条` }}
            onChange={(p)=>{ setRuleSummaryPage(p.current || 1); setRuleSummaryPageSize(p.pageSize || 20); }}
          />
        </TabPane>

        <TabPane tab="最终收费规则-管理" key="rule-effective-manage">
          {/* 使用说明 */}
          <Alert
            type="info"
            showIcon
            message="使用说明（可编辑）"
            description={(
              <div>
                <div>· 本页聚焦“最终生效规则”的运维管理，可直接<span style={{ fontWeight: 600 }}>编辑规则/管理梯度/去试算</span>。</div>
                <div>· 修改保存后即刻生效（受有效期与屏蔽/覆盖影响），建议在试算页验证命中与金额。</div>
                <div>· 涉及价格/口径调整建议配合审计日志与对账导出留痕；如需只读查看，请使用“最终收费规则-只读”。</div>
              </div>
            )}
            className="mb-3"
          />
          {/* 复用管理员生效视图（带编辑/梯度/试算） */}
          <div style={{ paddingTop: 8 }}>
            <BillingRulesPage />
          </div>
        </TabPane>

        <TabPane tab="系统级设置" key="system-rules">
          <Alert
            type="info"
            showIcon
            message="使用说明"
            description={(
              <div>
                <div>· 新增系统默认规则：选择操作类型 → 规则类型（固定/梯度） → 计费单位 → 单价/梯度 → 生效期。</div>
                <div>· 通过下方"规则下发"同步到客户/项目；客户或项目可覆盖或屏蔽。</div>
                <div>· 周期费用示例：仓储费使用 计费单位=PER_CBM，计费周期=DAY。</div>
              </div>
            )}
            className="mb-3"
          />
          <div className="mb-2 flex items-center justify-between">
            <div className="font-semibold">操作类型字典（系统级）</div>
            <div className="flex items-center gap-2">
              <Button type="primary" onClick={() => { setEditingOp(null); opForm.resetFields(); opForm.setFieldsValue({ scope_level: 'system' }); setVisibleOpModal(true); }}>新增操作类型</Button>
              <Button onClick={async () => { await fetchOpTypes(); await buildOpTypeUsageSummary(); }}>刷新字典</Button>
            </div>
          </div>
          <div className="mb-2 flex items-center gap-2">
            <Input.Search
              allowClear
              placeholder="搜索关键字（名称/编码/描述）"
              style={{ width: 260 }}
              value={sysOpKeyword}
              onChange={(e) => setSysOpKeyword(e.target.value)}
              onSearch={(v) => setSysOpKeyword(v)}
            />
            <Select
              allowClear
              placeholder="筛选类别（可选）"
              style={{ width: 180 }}
              value={sysOpCategoryFilter}
              onChange={(v) => setSysOpCategoryFilter(v as string | undefined)}
              options={[
                { value: 'INBOUND', label: '入库' },
                { value: 'INVENTORY_MANAGEMENT', label: '在库管理' },
                { value: 'OUTBOUND', label: '出库' },
                { value: 'VALUE_ADDED', label: '增值服务' },
                { value: 'ADJUSTMENT', label: '调整' },
              ]}
            />
          </div>
          <div className="mb-2 text-xs text-gray-500">调试：系统级操作类型数量 {Array.isArray(systemScopedOpTypes) ? systemScopedOpTypes.length : 0}</div>
          <Table rowKey="id" size="small" dataSource={systemOpsFiltered} columns={columnsOp}
            pagination={{ current: sysOpPage, pageSize: sysOpPageSize, total: systemOpsFiltered.length, showSizeChanger: true, pageSizeOptions: [10,20,50,100] as any, showTotal: (total, range) => `共${total}条，当前${range[0]}-${range[1]}条` }}
            onChange={(p)=>{ setSysOpPage(p.current || 1); setSysOpPageSize(p.pageSize || 10); }}
            className="mb-4" />
          <div className="mb-4 flex items-center justify-between">
            <div className="font-semibold">规则列表（系统级）</div>
            <div className="flex items-center gap-2">
              <Button type="primary" onClick={() => { setEditingRule(null); ruleForm.resetFields(); setModalLevel('system'); setVisibleRuleModal(true); }}>新增系统级规则</Button>
              <Button onClick={async () => { await fetchSystemRulesOnly(); }}>刷新规则列表</Button>
            </div>
          </div>
          <div className="mb-2 flex items-center gap-2">
            <Select
              value={sysRulesType}
              onChange={(v) => setSysRulesType(v as any)}
              options={[
                { value: 'all', label: '全部类型' },
                { value: 'flat', label: '固定收费' },
                { value: 'tiered', label: '梯度收费' },
              ]}
              style={{ width: 140 }}
            />
            <Select
              allowClear
              placeholder="筛选类别（可选）"
              style={{ width: 180 }}
              value={sysRulesCategory}
              onChange={(v) => setSysRulesCategory(v as string | undefined)}
              options={[
                { value: 'INBOUND', label: '入库' },
                { value: 'INVENTORY_MANAGEMENT', label: '在库管理' },
                { value: 'OUTBOUND', label: '出库' },
                { value: 'VALUE_ADDED', label: '增值服务' },
                { value: 'ADJUSTMENT', label: '调整' },
              ]}
            />
          </div>
          <Table rowKey="id" loading={loading} dataSource={sysRulesFiltered} columns={columnsRuleSystem as any}
            pagination={{ current: sysRulesPage, pageSize: sysRulesPageSize, total: sysRulesFiltered.length, showSizeChanger: true, pageSizeOptions: [10,20,50,100] as any, showTotal: (total, range) => `共${total}条，当前${range[0]}-${range[1]}条` }}
            onChange={(p)=>{ setSysRulesPage(p.current || 1); setSysRulesPageSize(p.pageSize || 20); }}
          />

          <Divider />
          <Alert
            type="info"
            showIcon
            message="规则下发（物化/对齐）"
            description={(
              <div>
                <div>· 物化=把系统级规则复制为客户/项目本层副本，用于"锁价、不再自动跟随系统"。</div>
                <div>· 模式：仅补齐缺失（安全，已有不动）/ 对齐并覆盖（强制以系统为准）。</div>
                <div>· 适用：初始化铺规则、批量对齐/回滚、冻结价格，或需要统一基线再微调。</div>
                <div>· 提示：默认自动继承即可使用，无需下发；"物化"是高级运维工具以获得可控的本层副本。</div>
                <div className="mt-2 font-semibold">推荐：新客户初始化流程</div>
                <div className="mt-1 font-semibold">何时物化下发</div>
                <div>仅在需要"锁价/批量对齐/统一结构模板"时，才从系统级"下发到客户"或从客户级"下发到项目"。</div>
                <div>日常不下发，保持轻量：新客户/项目自动继承即可用；个性化时再"覆盖/屏蔽"。</div>
                <div>1) 在系统级维护完整"标准价目表"（操作类型与收费规则）。</div>
                <div>2) 新建客户/项目后，先执行"下发到客户/项目"，复制系统基线为本层规则（可锁价）。</div>
                <div>3) 前往客户/项目"最终生效规则"进行个性化：</div>
                <div style={{ paddingLeft: 12 }}>· 覆盖：本层生成可编辑规则，改价/改单位/设有效期；</div>
                <div style={{ paddingLeft: 12 }}>· 屏蔽：同键不再回退上层；本层无规则则最终不收费；</div>
                <div style={{ paddingLeft: 12 }}>· 专属：新增客户/项目专属操作类型与规则（作用域=客户/项目）；</div>
                <div style={{ paddingLeft: 12 }}>· 并存：需要多套方案时填写"变体键 variant_key"区分并存；</div>
                <div>4) 在"最终生效规则"核对价格；业务事件触发后端自动计费并生成收费记录。</div>
              </div>
            )}
            className="mb-3"
          />
          <ApplyActions onApplyToCustomer={applyToCustomer} onApplyToProject={applyToProject} />

          {systemDebug && (
            <div className="mt-4 p-3 bg-gray-50 border rounded text-xs text-gray-600">
              <div className="font-semibold mb-1">调试信息（系统级列表）</div>
              <div>params: {JSON.stringify(systemDebug.params)}</div>
              <div>returned: {JSON.stringify(systemDebug.returned)}</div>
            </div>
          )}
        </TabPane>

        <TabPane tab="客户级设置" key="customer-settings">
          <Alert
            type="info"
            showIcon
            message="使用说明"
            description={(
              <div>
                <div>· 选择客户后点击"查询"。</div>
                <div>· 可在本页新增/编辑/启用/禁用客户级规则，或屏蔽继承系统级规则。</div>
                <div>"最终生效规则"展示当前时间实际生效（客户→系统）。</div>
              </div>
            )}
            className="mb-3"
          />
          <div className="mb-4 flex items-center gap-2">
            <Select
              placeholder="选择客户（支持模糊搜索）"
              showSearch
              allowClear
              style={{ width: 280 }}
              loading={customerLoading}
              value={scopeCustomerId}
              onFocus={ensureCustomersLoaded}
              onChange={(v) => { setScopeLevel('customer'); setScopeCustomerId(v as number | undefined); setScopeProjectId(undefined); setProjectOptions([]); }}
              optionFilterProp="label"
              defaultActiveFirstOption
              options={customerOptions}
            />
            <Button onClick={() => { setScopeLevel('customer'); fetchRulesByScope(); }}>查询</Button>
          </div>
          <div className="mb-3 flex items-center justify-between">
            <div className="font-semibold">操作类型字典（客户级）</div>
            <div className="flex items-center gap-2">
              <Button type="primary" onClick={() => { if (!scopeCustomerId) { message.warning('请先选择客户再新增操作类型'); return; } setEditingOp(null); opForm.resetFields(); opForm.setFieldsValue({ scope_level: 'customer' }); setVisibleOpModal(true); }}>新增操作类型</Button>
              <Button onClick={fetchOpTypes}>刷新字典</Button>
            </div>
          </div>
          <div className="mb-2 text-xs text-gray-500">调试：客户ID {String(scopeCustomerId || '-') } · 客户级操作类型数量 {Array.isArray(customerScopedOpTypes) ? customerScopedOpTypes.length : 0}</div>
          <Table rowKey="id" size="small" dataSource={customerScopedOpTypes} columns={columnsOp}
            pagination={{ current: custOpPage, pageSize: custOpPageSize, total: (customerScopedOpTypes.length || 0), showSizeChanger: true, pageSizeOptions: [10,20,50,100] as any, showTotal: (total, range) => `共${total}条，当前${range[0]}-${range[1]}条` }}
            onChange={(p)=>{ setCustOpPage(p.current || 1); setCustOpPageSize(p.pageSize || 10); }}
            className="mb-4" />
          <div className="mb-2 flex items-center justify-between">
            <div className="font-semibold">规则列表（客户级）</div>
            <div className="flex items-center gap-2">
              <Button type="primary" onClick={() => { if (!scopeCustomerId) { message.warning('请先选择客户再新增规则'); return; } setEditingRule(null); ruleForm.resetFields(); setModalLevel('customer'); setVisibleRuleModal(true); }}>新增客户级规则</Button>
              <Button onClick={() => fetchRulesByScope()}>刷新规则列表</Button>
            </div>
          </div>
          <div className="mb-2 font-semibold">最终生效规则</div>
          {/* 调试信息：屏蔽/覆盖筛选、局部上下文与最近一次屏蔽请求体 */}
          {(() => {
            try {
              return (
                <div className="mb-2 p-2 text-xs bg-gray-50 border rounded text-gray-600">
                  <div>DEBUG · scopeLevel={String(scopeLevel)} · customer={String(scopeCustomerId||'-')} · project={String(scopeProjectId||'-')}</div>
                  <div>DEBUG · 仅显示：masked={String(effCustOnlyMasked)} · covered={String(effCustOnlyCovered)}</div>
                  <div>DEBUG · rules.count={String(effectiveRules?.length||0)}</div>
                </div>
              );
            } catch {}
            return null;
          })()}
          <div className="mb-2 flex items-center gap-2">
            <Select
              value={effCustType}
              onChange={(v) => setEffCustType(v as any)}
              options={[
                { value: 'all', label: '全部类型' },
                { value: 'flat', label: '固定收费' },
                { value: 'tiered', label: '梯度收费' },
              ]}
              style={{ width: 140 }}
            />
            <Select
              value={effCustSource}
              onChange={(v) => setEffCustSource(v as any)}
              options={[
                { value: 'all', label: '全部来源' },
                { value: 'system', label: '系统' },
                { value: 'customer', label: '客户' },
                { value: 'project', label: '项目' },
              ]}
              style={{ width: 140 }}
            />
            <Select
              allowClear
              placeholder="按操作类别（可选）"
              style={{ width: 180 }}
              value={effCustCategory}
              onChange={(v) => setEffCustCategory(v as string | undefined)}
              options={[
                { value: 'INBOUND', label: '入库' },
                { value: 'INVENTORY_MANAGEMENT', label: '在库管理' },
                { value: 'OUTBOUND', label: '出库' },
                { value: 'VALUE_ADDED', label: '增值服务' },
                { value: 'ADJUSTMENT', label: '调整' },
              ]}
            />
            <span className="text-gray-500">仅显示：</span>
            <Switch checked={effCustOnlyMasked} onChange={(v) => setEffCustOnlyMasked(v)} />
            <span className="text-gray-700 mr-2">已屏蔽</span>
            <Switch checked={effCustOnlyCovered} onChange={(v) => setEffCustOnlyCovered(v)} />
            <span className="text-gray-700">已覆盖</span>
          </div>
          <Table rowKey={(r) => `${r.operation_type}-${r.billing_unit}-${r.min_value}-${r.max_value}-${r.source_level}-${r.variant_key || 'NA'}`} loading={loading} dataSource={effCustomerFiltered} columns={columnsEffective as any}
            pagination={{ current: effCustPage, pageSize: effCustPageSize, total: effCustomerFiltered.length, showSizeChanger: true, pageSizeOptions: [10,20,50,100] as any, showTotal: (total, range) => `共${total}条，当前${range[0]}-${range[1]}条` }}
            onChange={(p)=>{ setEffCustPage(p.current || 1); setEffCustPageSize(p.pageSize || 10); }}
          />
          <Divider />
          <div className="mb-2 font-semibold">本层物化规则</div>
          {/* 调试信息：本层物化规则条数与筛选 */}
          {(() => {
            try {
              const total = Array.isArray(rules) ? rules.length : 0;
              return (
                <div className="mb-2 p-2 text-xs bg-gray-50 border rounded text-gray-600">
                  <div>DEBUG · materialized.count={String(total)}</div>
                </div>
              );
            } catch {}
            return null;
          })()}
          <div className="mb-2 flex items-center gap-2">
            <Select
              value={custRulesType}
              onChange={(v) => setCustRulesType(v as any)}
              options={[
                { value: 'all', label: '全部类型' },
                { value: 'flat', label: '固定收费' },
                { value: 'tiered', label: '梯度收费' },
              ]}
              style={{ width: 140 }}
            />
            <Select
              allowClear
              placeholder="按操作类别（可选）"
              style={{ width: 180 }}
              value={custRulesCategory}
              onChange={(v) => setCustRulesCategory(v as string | undefined)}
              options={[
                { value: 'INBOUND', label: '入库' },
                { value: 'INVENTORY_MANAGEMENT', label: '在库管理' },
                { value: 'OUTBOUND', label: '出库' },
                { value: 'VALUE_ADDED', label: '增值服务' },
                { value: 'ADJUSTMENT', label: '调整' },
              ]}
            />
          </div>
          <Alert
            type="info"
            showIcon
            message="什么是物化规则？如何使用"
            description={(
              <div>
                <div>· 物化=把上层（系统/客户）的规则复制为本层记录，从此本层可独立维护，不再自动跟随上层。</div>
                <div>· 使用建议：当需"锁价"或对该客户进行个性化定价时，在此新增/编辑本层规则；删除本层记录或"恢复继承"可重新回到自动继承。</div>
                <div>· 安全提示：本层物化后，上层改动不会自动同步到此处；请定期审视是否仍需锁定或对齐。</div>
              </div>
            )}
            className="mb-3"
          />
          <Table rowKey="id" loading={loading} dataSource={custRulesFiltered2} columns={columnsMaterialized as any}
            pagination={{ current: custRulesPage, pageSize: custRulesPageSize, total: custRulesFiltered2.length, showSizeChanger: true, pageSizeOptions: [10,20,50,100] as any, showTotal: (total, range) => `共${total}条，当前${range[0]}-${range[1]}条` }}
            onChange={(p)=>{ setCustRulesPage(p.current || 1); setCustRulesPageSize(p.pageSize || 10); }}
          />
          {scopedDebug && (
            <div className="mt-4 p-3 bg-gray-50 border rounded text-xs text-gray-600">
              <div className="font-semibold mb-1">调试信息（客户级列表）</div>
              <div>params: {JSON.stringify(scopedDebug.params)}</div>
              <div>returned: {JSON.stringify(scopedDebug.returned)}</div>
              {ruleSaveDebug && (
                <>
                  <div className="font-semibold mt-2">调试信息（规则保存）</div>
                  <div>payload: {JSON.stringify(ruleSaveDebug.payload)}</div>
                  {'response' in ruleSaveDebug ? <div>response: {JSON.stringify(ruleSaveDebug.response)}</div> : null}
                </>
              )}
            </div>
          )}
        </TabPane>

        <TabPane tab="项目级设置" key="project-settings">
          <Alert
            type="info"
            showIcon
            message="使用说明"
            description={(
              <div>
                <div>· 先选择客户与项目后点击"查询"。</div>
                <div>· 可在本页新增/编辑/启用/禁用本项目规则，或屏蔽继承客户/系统级规则。</div>
                <div>"最终生效规则"展示当前时间实际生效（项目→客户→系统）。</div>
              </div>
            )}
            className="mb-3"
          />
          <div className="mb-4 flex items-center gap-2">
            <Select
              placeholder="选择客户"
              showSearch
              allowClear
              style={{ width: 240 }}
              loading={customerLoading}
              value={scopeCustomerId}
              onFocus={ensureCustomersLoaded}
              onChange={(v) => { setScopeLevel('project'); setScopeCustomerId(v as number | undefined); setScopeProjectId(undefined); setProjectOptions([]); }}
              optionFilterProp="label"
              defaultActiveFirstOption
              options={customerOptions}
            />
            <Select
              placeholder={scopeCustomerId ? '选择项目（支持模糊搜索）' : '先选择客户'}
              showSearch
              allowClear
              style={{ width: 300 }}
              loading={projectLoading}
              disabled={!scopeCustomerId}
              value={scopeProjectId}
              onFocus={() => searchProjects('')}
              onSearch={(val) => searchProjects(val)}
              filterOption={false}
              onChange={(v) => setScopeProjectId(v as number | undefined)}
              defaultActiveFirstOption
              options={projectOptions}
            />
            <Button onClick={() => { setScopeLevel('project'); fetchRulesByScope(); }}>查询</Button>
          </div>
          <div className="mb-3 flex items-center justify-between">
            <div className="font-semibold">操作类型字典（项目级）</div>
            <div className="flex items-center gap-2">
              <Button type="primary" onClick={() => { if (!scopeCustomerId) { message.warning('请先选择客户'); return; } if (!scopeProjectId) { message.warning('请先选择项目'); return; } setEditingOp(null); opForm.resetFields(); opForm.setFieldsValue({ scope_level: 'project' }); setVisibleOpModal(true); }}>新增操作类型</Button>
              <Button onClick={fetchOpTypes}>刷新字典</Button>
            </div>
          </div>
          <div className="mb-2 text-xs text-gray-500">调试：客户ID {String(scopeCustomerId || '-')} · 项目ID {String(scopeProjectId || '-')} · 项目级操作类型数量 {Array.isArray(projectScopedOpTypes) ? projectScopedOpTypes.length : 0}</div>
          <Table rowKey="id" size="small" dataSource={projectScopedOpTypes} columns={columnsOp}
            pagination={{ current: projOpPage, pageSize: projOpPageSize, total: (projectScopedOpTypes.length || 0), showSizeChanger: true, pageSizeOptions: [10,20,50,100] as any, showTotal: (total, range) => `共${total}条，当前${range[0]}-${range[1]}条` }}
            onChange={(p)=>{ setProjOpPage(p.current || 1); setProjOpPageSize(p.pageSize || 10); }}
            className="mb-4" />
          <div className="mb-2 flex items-center justify-between">
            <div className="font-semibold">规则列表（项目级）</div>
            <div className="flex items-center gap-2">
              <Button type="primary" onClick={() => { if (!scopeCustomerId) { message.warning('请先选择客户'); return; } if (!scopeProjectId) { message.warning('请先选择项目'); return; } setEditingRule(null); ruleForm.resetFields(); setModalLevel('project'); setVisibleRuleModal(true); }}>新增项目级规则</Button>
              <Button onClick={() => fetchRulesByScope()}>刷新规则列表</Button>
            </div>
          </div>
          <div className="mb-2 font-semibold">最终生效规则</div>
          <div className="mb-2 flex items-center gap-2">
            <Select
              value={effProjType}
              onChange={(v) => setEffProjType(v as any)}
              options={[
                { value: 'all', label: '全部类型' },
                { value: 'flat', label: '固定收费' },
                { value: 'tiered', label: '梯度收费' },
              ]}
              style={{ width: 140 }}
            />
            <Select
              value={effProjSource}
              onChange={(v) => setEffProjSource(v as any)}
              options={[
                { value: 'all', label: '全部来源' },
                { value: 'system', label: '系统' },
                { value: 'customer', label: '客户' },
                { value: 'project', label: '项目' },
              ]}
              style={{ width: 140 }}
            />
            <Select
              allowClear
              placeholder="按操作类别（可选）"
              style={{ width: 180 }}
              value={effProjCategory}
              onChange={(v) => setEffProjCategory(v as string | undefined)}
              options={[
                { value: 'INBOUND', label: '入库' },
                { value: 'INVENTORY_MANAGEMENT', label: '在库管理' },
                { value: 'OUTBOUND', label: '出库' },
                { value: 'VALUE_ADDED', label: '增值服务' },
                { value: 'ADJUSTMENT', label: '调整' },
              ]}
            />
            <span className="text-gray-500">仅显示：</span>
            <Switch checked={effProjOnlyMasked} onChange={(v) => setEffProjOnlyMasked(v)} />
            <span className="text-gray-700 mr-2">已屏蔽</span>
            <Switch checked={effProjOnlyCovered} onChange={(v) => setEffProjOnlyCovered(v)} />
            <span className="text-gray-700">已覆盖</span>
          </div>
          <Table rowKey={(r) => `${r.operation_type}-${r.billing_unit}-${r.min_value}-${r.max_value}-${r.source_level}-${r.variant_key || 'NA'}`} loading={loading} dataSource={effProjectFiltered} columns={columnsEffective as any}
            pagination={{ current: effProjPage, pageSize: effProjPageSize, total: effProjectFiltered.length, showSizeChanger: true, pageSizeOptions: [10,20,50,100] as any, showTotal: (total, range) => `共${total}条，当前${range[0]}-${range[1]}条` }}
            onChange={(p)=>{ setEffProjPage(p.current || 1); setEffProjPageSize(p.pageSize || 10); }}
          />
          <Divider />
          <div className="mb-2 font-semibold">本层物化规则</div>
          <div className="mb-2 flex items-center gap-2">
            <Select
              value={projRulesType}
              onChange={(v) => setProjRulesType(v as any)}
              options={[
                { value: 'all', label: '全部类型' },
                { value: 'flat', label: '固定收费' },
                { value: 'tiered', label: '梯度收费' },
              ]}
              style={{ width: 140 }}
            />
            <Select
              allowClear
              placeholder="按操作类别（可选）"
              style={{ width: 180 }}
              value={projRulesCategory}
              onChange={(v) => setProjRulesCategory(v as string | undefined)}
              options={[
                { value: 'INBOUND', label: '入库' },
                { value: 'INVENTORY_MANAGEMENT', label: '在库管理' },
                { value: 'OUTBOUND', label: '出库' },
                { value: 'VALUE_ADDED', label: '增值服务' },
                { value: 'ADJUSTMENT', label: '调整' },
              ]}
            />
          </div>
          <Table rowKey="id" loading={loading} dataSource={projRulesFiltered2} columns={columnsMaterialized as any}
            pagination={{ current: projRulesPage, pageSize: projRulesPageSize, total: projRulesFiltered2.length, showSizeChanger: true, pageSizeOptions: [10,20,50,100] as any, showTotal: (total, range) => `共${total}条，当前${range[0]}-${range[1]}条` }}
            onChange={(p)=>{ setProjRulesPage(p.current || 1); setProjRulesPageSize(p.pageSize || 10); }}
          />
          {scopedDebug && (
            <div className="mt-4 p-3 bg-gray-50 border rounded text-xs text-gray-600">
              <div className="font-semibold mb-1">调试信息（项目级列表）</div>
              <div>params: {JSON.stringify(scopedDebug.params)}</div>
              <div>returned: {JSON.stringify(scopedDebug.returned)}</div>
            </div>
          )}
        </TabPane>

        <TabPane tab="仓储费监控" key="storage-monitor">
          <Alert type="info" showIcon message="按日查看计提明细/异常，触发重算与过账" className="mb-3" />
          <div className="mb-3 flex items-center gap-8 flex-wrap">
            <Space>
              <span>计费日期</span>
              <DatePicker onChange={(d) => setStorageDate(d ? d.format('YYYY-MM-DD') : undefined)} />
            </Space>
            <Space>
              <span>项目</span>
              <Select allowClear showSearch style={{ width: 280 }} loading={storageProjLoading}
                      value={storageProjectId} onFocus={() => searchProjectsForMonitor('')}
                      onSearch={(v)=>searchProjectsForMonitor(v)} filterOption={false}
                      options={storageProjOptions} onChange={(v)=>setStorageProjectId(v as number|undefined)} />
            </Space>
            <Space>
              <span>仓库</span>
              <Select allowClear showSearch style={{ width: 260 }} loading={wareLoading}
                      value={storageWarehouseId} onFocus={ensureWarehouses}
                      options={warehouses} onChange={(v)=>setStorageWarehouseId(v as number|undefined)} />
            </Space>
            <Space>
              <Button onClick={fetchDailyCharges} loading={dailyLoading}>加载日度明细</Button>
              <Button onClick={fetchAnomalies} loading={anomalyLoading}>加载异常</Button>
            </Space>
            <Space>
              <Button type="dashed" onClick={execRecalc} loading={recalcLoading}>触发重算</Button>
              <Button type="primary" onClick={execBook} loading={bookLoading}>过账到收费记录</Button>
            </Space>
          </div>
          <Divider>日度明细 ({dailyTotal})</Divider>
          <Table rowKey={(r:any)=>String(r.id)} size="small" loading={dailyLoading} dataSource={dailyRows}
                 pagination={{ pageSize: 10, showSizeChanger: true }}
                 columns={[
                   { title: '库存单元', dataIndex: 'unit_id', render: (v:any)=> storageUnitCodeMap[String(v)] || String(v) },
                   { title: '仓库', dataIndex: 'warehouse_id', render: (v:any)=> storageWarehouseMap[String(v)] || String(v) },
                   { title: '项目', dataIndex: 'project_id', render: (v:any)=> {
                     const info = storageProjectMap[String(v)] || {} as any;
                     const code = info.code || String(v);
                     const name = info.name || '';
                     return `${code}${name ? ` - ${name}` : ''}`;
                   } },
                   { title: '库龄段', dataIndex: 'age_bucket' },
                   { title: '数量', dataIndex: 'qty' },
                   { title: '单件体积(m³)', dataIndex: 'unit_volume_m3' },
                   { title: '总计体积(m³)', dataIndex: 'total_volume_m3' },
                   { title: '费率', dataIndex: 'rate' },
                   { title: '金额', dataIndex: 'amount' },
                   { title: '规则集', dataIndex: 'rule_set_id', render: (_:any, r:any)=> `${r.rule_set_id || '-'}@v${r.rule_version || '-'}` },
                 ]}
          />
          <Divider>异常 ({anomalyTotal})</Divider>
          <Table rowKey={(r:any)=>String(r.id)} size="small" loading={anomalyLoading} dataSource={anomalyRows}
                 pagination={{ pageSize: 10, showSizeChanger: true }}
                 columns={[
                   { title: '类型', dataIndex: 'anomaly_type' },
                   { title: '说明', dataIndex: 'message' },
                   { title: '日期', dataIndex: 'charge_date' },
                   { title: '项目', dataIndex: 'project_id', render: (v:any)=> {
                     const info = storageProjectMap[String(v)] || {} as any;
                     const code = info.code || String(v);
                     const name = info.name || '';
                     return `${code}${name ? ` - ${name}` : ''}`;
                   } },
                   { title: '仓库', dataIndex: 'warehouse_id', render: (v:any)=> storageWarehouseMap[String(v)] || String(v) },
                   { title: '库存单元', dataIndex: 'unit_id', render: (v:any)=> storageUnitCodeMap[String(v)] || String(v) },
                   { title: '层ID', dataIndex: 'layer_id' },
                   { title: '规则集', dataIndex: 'rule_set_id' },
                   { title: '状态', dataIndex: 'status' },
                 ]}
          />
        </TabPane>
      </Tabs>

      {/* 梯度详情（只读） */}
      <Modal
        title={(
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', paddingRight: 48 }}>
            <span>梯度详情 - {tierViewRule?.operation_type_name || ''}</span>
            <span>维度：{tierBasisLabel(tierViewRule?.tier_basis)}</span>
          </div>
        )}
        open={tierViewOpen}
        onCancel={() => setTierViewOpen(false)}
        footer={null}
        destroyOnClose>
        <Table
          rowKey={(r, idx) => String(r.id || `tier-${idx}`)}
          loading={tierViewLoading}
          dataSource={tierViewList}
          pagination={false}
          columns={[
            { title: '区间最小', dataIndex: 'min_value', render: (v: any) => (v === null || v === undefined ? '0' : v) },
            { title: '区间最大(空=无上限)', dataIndex: 'max_value', render: (v: any) => (v === null || v === undefined ? '-' : v) },
            { title: '单价', dataIndex: 'unit_price', render: (v: any) => (v != null ? Number(v).toFixed(2) : '-') },
            { title: '展示备注', dataIndex: 'tier_remark', render: (v: any) => v || '-' },
          ]}
        />
      </Modal>

      {/* 展示配置 - 操作类型（Drawer） */}
      <Drawer
        title={`操作类型展示配置${opPresTarget ? ` - ${opPresTarget.name || ''}` : ''}`}
        open={opPresModalOpen}
        width={520}
        onClose={() => setOpPresModalOpen(false)}
        extra={
          <Space>
            <Select allowClear placeholder="默认语言" style={{ width: 140 }} value={opPresLocale ?? 'zh-CN'} onChange={(v) => setOpPresLocale(v)} options={[{ value: 'zh-CN', label: '中文' }, { value: 'en-US', label: 'English' }]} />
            <Button type="primary" onClick={async () => {
              const v = await opPresForm.validateFields();
              if (!opPresTarget) { setOpPresModalOpen(false); return; }
              const locale = opPresLocale || previewLocale || undefined;
              // 作用域校验
              if (modalOpScope === 'customer' && !scopeCustomerId) { message.warning('请先选择客户'); return; }
              if (modalOpScope === 'project' && (!scopeCustomerId || !scopeProjectId)) { message.warning('请先选择客户与项目'); return; }
              const payload: any = {
                operation_type: opPresTarget.id,
                scope_level: modalOpScope,
                customer_id: modalOpScope === 'customer' || modalOpScope === 'project' ? scopeCustomerId : undefined,
                project_id: modalOpScope === 'project' ? scopeProjectId : undefined,
                locale,
                display_name: v.display_name || null,
                description: v.description || null,
                examples: v.examples || null,
              };
              try {
                await request.post('/api/v1/billing/presentations/operation-types/', payload);
                message.success('展示配置已保存');
              } catch (e: any) {
                try {
                  const list = await request.get('/api/v1/billing/presentations/operation-types/', { params: {
                    operation_type: opPresTarget.id,
                    scope_level: modalOpScope,
                    customer_id: modalOpScope === 'customer' || modalOpScope === 'project' ? scopeCustomerId : undefined,
                    project_id: modalOpScope === 'project' ? scopeProjectId : undefined,
                    locale,
                  }});
                  const exist = Array.isArray(list.data?.results) ? (list.data.results[0] || null) : (Array.isArray(list.data) ? list.data[0] : null);
                  if (exist && exist.id) {
                    await request.put(`/api/v1/billing/presentations/operation-types/${exist.id}/`, payload);
                    message.success('展示配置已更新');
                  } else {
                    throw e;
                  }
                } catch {
                  message.error('保存展示配置失败');
                }
              }
              setOpPresModalOpen(false);
              await fetchRulesByScope();
            }}>保存</Button>
          </Space>
        }
      >
        <Form form={opPresForm} layout="vertical">
          <Form.Item label="展示名称" name="display_name">
            <Input placeholder="客户可见名称（如：入库卸货费）" />
          </Form.Item>
          <Form.Item label="说明" name="description">
            <Input.TextArea rows={4} placeholder="简要说明，用于帮助客户理解收费项目规则" />
          </Form.Item>
          <Form.Item label="举例" name="examples">
            <Input.TextArea rows={4} placeholder="示例：单次上架拆零操作将产生一次计费" />
          </Form.Item>
        </Form>
      </Drawer>

      <Modal title={editingOp ? '编辑操作类型' : '新增操作类型'} open={visibleOpModal} onOk={saveOpType} onCancel={() => setVisibleOpModal(false)} confirmLoading={loading} destroyOnClose>
        {(modalOpScope === 'customer' || modalOpScope === 'project') && (
          <Alert
            type="info"
            showIcon
            message="当前上下文"
            description={(
              <div>
                {modalOpScope === 'customer' && (<div>客户：{getCustomerLabel(scopeCustomerId)}</div>)}
                {modalOpScope === 'project' && (
                  <>
                    <div>客户：{getCustomerLabel(scopeCustomerId)}</div>
                    <div>项目：{getProjectLabel(scopeProjectId)}</div>
                  </>
                )}
              </div>
            )}
            className="mb-3"
          />
        )}
        <Form form={opForm} layout="vertical" initialValues={{ is_active: true, scope_level: modalOpScope }}>
          <Form.Item label="操作类型级别" name="scope_level">
            <Select disabled options={[{ value: 'system', label: '系统' }, { value: 'customer', label: '客户' }, { value: 'project', label: '项目' }]} />
          </Form.Item>
          <Form.Item label="名称" name="name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="短码" name="short_code">
            <Input placeholder="如：OT_SYS_26" />
          </Form.Item>
          <Form.Item label="类别" name="category" rules={[{ required: true }]}>
            <Select options={[
              { value: 'INBOUND', label: '入库' },
              { value: 'INVENTORY_MANAGEMENT', label: '在库管理' },
              { value: 'OUTBOUND', label: '出库' },
              { value: 'VALUE_ADDED', label: '增值服务' },
              { value: 'ADJUSTMENT', label: '调整' },
            ]} />
          </Form.Item>
          <Form.Item label="序号" name="order_index" initialValue={0}>
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item label="描述" name="description">
            <Input.TextArea rows={3} />
          </Form.Item>
          <Form.Item label="启用" name="is_active" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title={(
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', paddingRight: 48 }}>
            <span>编辑梯度 - {tierRule?.operation_type_name || ''}</span>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
              <span>维度：{tierBasisLabel(tierRule?.tier_basis)}</span>
              <Button size="small" type="primary" onClick={saveAllTiers} loading={tierLoading}>全部保存</Button>
            </span>
          </div>
        )}
        open={tierModalOpen}
        onCancel={() => setTierModalOpen(false)}
        footer={null}
        destroyOnClose>
        {/* 位置一：弹窗顶部提示 */}
        <div className="mb-2">
          <Alert
            type="info"
            showIcon
            message="梯度区间说明"
            description={(
              <div>
                <div>区间最小表示 ≥（包含），区间最大表示 ＜（不包含）。</div>
                <div>相邻梯度边界应对齐：上一个最大值 = 下一个最小值，避免边界漏收费。</div>
                {tierRule?.tier_basis === 'AGE_DAY' && (
                  <div style={{ color: '#d46b08' }}>
                    库龄(天)梯度（仓储费）：区间最大不含，请写成 0-31、31-61、61-91、91-空(无上限)，不要写成 0-30、31-60。第30/60/90天等边界日会因匹配不到梯度而不计费。
                  </div>
                )}
              </div>
            )}
            className="mb-2"
          />
          <Button onClick={addTierRow}>新增梯度行</Button>
        </div>
        <Table
          rowKey={(r, idx) => String(r.id || `new-${idx}`)}
          dataSource={tiers}
          loading={tierLoading}
          pagination={false}
          columns={[
            { title: (
              <div>
                <div>区间最小</div>
                <div style={{ fontSize: 12, color: '#999' }}>（≥，包含）</div>
              </div>
            ), dataIndex: 'min_value', render: (v: any, _: any, index: number) => (
              <InputNumber value={v} placeholder="0" onChange={(val) => setTiers(prev => prev.map((r, i) => i===index ? { ...r, min_value: val } : r))} style={{ width: '100%' }} />
            ) },
            { title: (
              <div>
                <div>区间最大</div>
                <div style={{ fontSize: 12, color: '#999' }}>（＜，不包含）</div>
              </div>
            ), dataIndex: 'max_value', render: (v: any, _: any, index: number) => (
              <InputNumber value={v} onChange={(val) => setTiers(prev => prev.map((r, i) => i===index ? { ...r, max_value: val } : r))} style={{ width: '100%' }} />
            ) },
            { title: '单价', dataIndex: 'unit_price', render: (v: any, _: any, index: number) => (
              <InputNumber min={0} step={0.01} precision={2} value={v} onChange={(val) => setTiers(prev => prev.map((r, i) => i===index ? { ...r, unit_price: val } : r))} style={{ width: '100%' }} />
            ) },
            { title: '操作', render: (_: any, __: any, index: number) => (
              <Space>
                <Button size="small" danger onClick={() => deleteTierRow(index)}>删除</Button>
              </Space>
            ) }
          ]}
        />
      </Modal>

        <Modal title={editingRule ? '编辑收费规则' : '新增收费规则'} open={visibleRuleModal} onOk={saveRule} onCancel={() => setVisibleRuleModal(false)} confirmLoading={loading} destroyOnClose>
        {(modalLevel === 'customer' || modalLevel === 'project') && (
          <Alert
            type="info"
            showIcon
            message="当前上下文"
            description={(
              <div>
                {modalLevel === 'customer' && (<div>客户：{getCustomerLabel(scopeCustomerId)}</div>)}
                {modalLevel === 'project' && (
                  <>
                    <div>客户：{getCustomerLabel(scopeCustomerId)}</div>
                    <div>项目：{getProjectLabel(scopeProjectId)}</div>
                  </>
                )}
              </div>
            )}
            className="mb-3"
          />
        )}
          <Alert
            type="warning"
            showIcon
            message="覆盖提示"
            description="只有生效日期与变体值等唯一键与上层规则完全一致时，才会视为覆盖（更新本层规则）；否则将创建并行的新规则。"
            className="mb-3"
          />
        <Form form={ruleForm} layout="vertical" initialValues={{ currency: 'USD', is_active: true, visible_in_customer_portal: true, tier_basis: 'QUANTITY', pricing_basis: 'QUANTITY', quantity_basis: 'QUANTITY' }}>
          <Form.Item label="操作类型" name="operation_type" rules={[{ required: true }]}>
            <Select
              showSearch
              optionFilterProp="label"
              options={opTypeOptionsForModal}
            />
          </Form.Item>
          <Form.Item label="规则类型" name="rule_type" rules={[{ required: true }]} initialValue={'flat'}>
            <Select options={[{ value: 'flat', label: '固定收费' }, { value: 'tiered', label: '梯度收费' }]} />
          </Form.Item>
          <Form.Item label="计费周期" name="accrual_period" initialValue={'NONE'}>
            <Select options={[{ value: 'NONE', label: '无' }, { value: 'DAY', label: '按天' }, { value: 'MONTH', label: '按月' }]} />
          </Form.Item>
          <Form.Item
            label="梯度维度"
            name="tier_basis"
            rules={[{ required: true, message: '请设置计费口径（梯度维度）' }]}
            extra="固定收费也必须设置口径，否则终审无法确定取值字段"
          >
            <Select options={[
              { value: 'QUANTITY', label: '数量' },
              { value: 'WEIGHT_G', label: '重量(克)' },
              { value: 'WEIGHT_KG', label: '重量(千克)' },
              { value: 'VOLUME_CUFT', label: '体积(立方英尺)' },
              { value: 'VOLUME_CBM', label: '体积(立方米)' },
              { value: 'VOLUME_CC', label: '体积(立方厘米)' },
              { value: 'AGE_DAY', label: '库龄(天)' },
            ]} />
          </Form.Item>
          <Form.Item label="定价口径（可选）" name="pricing_basis" extra="为空则回退梯度维度">
            <Select allowClear options={[
              { value: 'QUANTITY', label: '数量' },
              { value: 'WEIGHT_G', label: '重量(克)' },
              { value: 'WEIGHT_KG', label: '重量(千克)' },
              { value: 'VOLUME_CUFT', label: '体积(立方英尺)' },
              { value: 'VOLUME_CBM', label: '体积(立方米)' },
              { value: 'VOLUME_CC', label: '体积(立方厘米)' },
              { value: 'AGE_DAY', label: '库龄(天)' },
            ]} />
          </Form.Item>
          <Form.Item label="计费数量口径（可选）" name="quantity_basis" extra="为空则回退梯度维度">
            <Select allowClear options={[
              { value: 'QUANTITY', label: '数量' },
              { value: 'WEIGHT_G', label: '重量(克)' },
              { value: 'WEIGHT_KG', label: '重量(千克)' },
              { value: 'VOLUME_CUFT', label: '体积(立方英尺)' },
              { value: 'VOLUME_CBM', label: '体积(立方米)' },
              { value: 'VOLUME_CC', label: '体积(立方厘米)' },
              { value: 'AGE_DAY', label: '库龄(天)' },
            ]} />
          </Form.Item>
          <Form.Item label="计费单位" name="billing_unit" rules={[{ required: true }]}>
            <Select options={[
              { value: 'PER_ITEM', label: '按件' },
              { value: 'PER_BOX', label: '按箱' },
              { value: 'PER_PALLET', label: '按托盘' },
              { value: 'PER_LB', label: '按磅' },
              { value: 'PER_KG', label: '按千克' },
              { value: 'PER_CUFT', label: '按立方英尺' },
              { value: 'PER_CBM', label: '按立方米' },
              { value: 'PER_CC', label: '按立方厘米' },
              { value: 'PER_VALUE', label: '按价值' },
              { value: 'PER_ORDER', label: '按订单' },
              { value: 'PER_MINUTE', label: '按分钟' },
            ]} />
          </Form.Item>
          <Form.Item label="展示单位（可选）" name="unit_label">
            <Input placeholder="如：组 / 张 / 次" />
          </Form.Item>
          <Form.Item label="区间最小值" name="min_value">
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item label="区间最大值" name="max_value">
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item noStyle shouldUpdate={(prev, cur) => prev.rule_type !== cur.rule_type}>
            {({ getFieldValue }) => (
              getFieldValue('rule_type') === 'tiered' ? (
                <div className="p-2 bg-gray-50 rounded border mb-3">
                  <div className="flex items-center justify-between mb-2">
                    <div className="font-medium">梯度区间</div>
                    {editingRule?.id && (
                      <Button size="small" onClick={() => openTierEditor(editingRule)}>编辑梯度</Button>
                    )}
                  </div>
                  <div className="text-xs text-gray-500">提示：保存规则后可在列表点击"编辑梯度"逐条维护 min/max/unit_price</div>
                </div>
              ) : (
                <Form.Item label="单价" name="unit_price" rules={[{ required: true }]}> 
                  <InputNumber style={{ width: '100%' }} min={0} step={0.01} precision={2} />
                </Form.Item>
              )
            )}
          </Form.Item>
          <Form.Item label="币种" name="currency" rules={[{ required: true }]}>
            <Select options={[{ value: 'USD', label: '美元' }, { value: 'CNY', label: '人民币' }, { value: 'EUR', label: '欧元' }]} />
          </Form.Item>
          <Form.Item label="生效开始" name="effective_from" rules={[{ required: true }]}>
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item label="生效结束" name="effective_to">
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item label="备注（可选）" name="remark">
            <Input.TextArea rows={2} />
          </Form.Item>
          <Form.Item label="启用" name="is_active" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label="客户后台可见" name="visible_in_customer_portal" valuePropName="checked" extra="关闭后：规则仍参与计费，但在客户后台收费规则列表中隐藏。">
            <Switch />
          </Form.Item>
          <Form.Item label="变体键（可选）" name="variant_key">
            <Input placeholder="如：A / B / special-01" />
          </Form.Item>
        </Form>
      </Modal>

      {/* 展示配置 - 规则 */}
      <Modal title={`规则展示配置${rulePresTarget ? ` - ${rulePresTarget.operation_type_name || ''}` : ''}`} open={rulePresModalOpen} onOk={async () => {
        const v = await rulePresForm.validateFields();
        if (!rulePresTarget) { setRulePresModalOpen(false); return; }
        const locale = rulePresLocale || previewLocale || 'zh-CN';
        const payload: any = { rule: rulePresTarget.id, locale, display_name_override: v.display_name_override || null, description_override: v.description_override || null, examples_override: v.examples_override || null, unit_label_override: v.unit_label_override || null, rule_remark_override: v.rule_remark_override || null };
        try {
          // 尝试创建；若存在则改为更新
          await request.post('/api/v1/billing/presentations/billing-rules/', payload);
          message.success('展示配置已保存');
        } catch (e: any) {
          try {
            const list = await request.get('/api/v1/billing/presentations/billing-rules/', { params: { rule: rulePresTarget.id, locale } });
            const exist = Array.isArray(list.data?.results) ? (list.data.results[0] || null) : (Array.isArray(list.data) ? list.data[0] : null);
            if (exist && exist.id) {
              await request.put(`/api/v1/billing/presentations/billing-rules/${exist.id}/`, payload);
              message.success('展示配置已更新');
            } else {
              await request.post('/api/v1/billing/presentations/billing-rules/', payload);
              message.success('展示配置已保存');
            }
          } catch {
            await request.post('/api/v1/billing/presentations/billing-rules/', payload);
            message.success('展示配置已保存');
          }
        }
        // 刷新 effective 以反映最新展示，并关闭弹窗
        await fetchRulesByScope();
        setRulePresModalOpen(false);
      }} onCancel={() => setRulePresModalOpen(false)} destroyOnClose>
        <Form form={rulePresForm} layout="vertical" initialValues={{ }}>
          <Form.Item label="语言（可选）">
            <Select allowClear placeholder="默认语言（为空使用默认）" value={rulePresLocale ?? 'zh-CN'} onChange={(v) => setRulePresLocale(v)} options={[{ value: 'zh-CN', label: '中文' }, { value: 'en-US', label: 'English' }]} />
          </Form.Item>
          <Form.Item label="展示名称覆盖" name="display_name_override">
            <Input placeholder="如：装箱基础费 / 装箱容积费" />
          </Form.Item>
          <Form.Item label="说明覆盖" name="description_override">
            <Input.TextArea rows={3} placeholder="展示说明（不影响计费口径）" />
          </Form.Item>
          <Form.Item label="举例覆盖" name="examples_override">
            <Input.TextArea rows={3} placeholder="展示示例（不影响计费口径）" />
          </Form.Item>
          <Form.Item label="展示单位覆盖" name="unit_label_override">
            <Input placeholder="如：组 / 张 / 次" />
          </Form.Item>
          <Form.Item label="规则备注覆盖" name="rule_remark_override">
            <Input.TextArea rows={2} />
          </Form.Item>
        </Form>
      </Modal>

      {/* 页面右上角：语言预览选择（简化放在页尾控件） */}
      <div className="fixed bottom-6 right-6 bg-white border rounded shadow px-3 py-2 text-sm">
        <span className="mr-2">预览语言:</span>
        <Select style={{ width: 140 }} allowClear placeholder="默认" value={previewLocale} onChange={(v) => { setPreviewLocale(v); setTimeout(() => fetchRulesByScope(), 0); }} options={[{ value: 'zh-CN', label: '中文' }, { value: 'en-US', label: 'English' }]} />
      </div>
    </div>
  );
};

const ApplyActions: React.FC<{ onApplyToCustomer: (customerId: number, overwrite: boolean) => void; onApplyToProject: (customerId: number, projectId: number, overwrite: boolean) => void; }> = ({ onApplyToCustomer, onApplyToProject }) => {
  const [form] = Form.useForm();
  const [mode, setMode] = React.useState<'fill' | 'overwrite'>('fill');
  // 本地下拉实现（与项目级选择保持一致的体验）
  const [customerOptionsLocal, setCustomerOptionsLocal] = React.useState<Array<{ value: number; label: string }>>([]);
  const [projectOptionsLocal, setProjectOptionsLocal] = React.useState<Array<{ value: number; label: string }>>([]);
  const [customerLoadingLocal, setCustomerLoadingLocal] = React.useState(false);
  const [projectLoadingLocal, setProjectLoadingLocal] = React.useState(false);

  const ensureCustomersLoadedLocal = async () => {
    if (customerOptionsLocal.length > 0) return;
    setCustomerLoadingLocal(true);
    try {
      const list = await getCustomerList({ onlyMain: true });
      const opts = (list || []).map((c: any) => {
        const sys = c.customer_code || c.profile?.customer_code || '';
        const name = c.name || c.username;
        const label = sys ? `${name} · ${sys}` : (name || '');
        return { value: Number(c.id), label };
      });
      setCustomerOptionsLocal(opts);
    } catch (e) {
      // ignore
    } finally {
      setCustomerLoadingLocal(false);
    }
  };

  const searchProjectsLocal = async (search?: string) => {
    const cid = form.getFieldValue('customer_id');
    if (!cid) { setProjectOptionsLocal([]); return; }
    setProjectLoadingLocal(true);
    try {
      const resp = await getProjectList({ page: 1, page_size: 50, search: search || '', customer: cid });
      const results = Array.isArray((resp.data as any)?.results) ? (resp.data as any).results : [];
      const opts = results.map((p: any) => ({ value: Number(p.id), label: `${p.project_code || p.id} - ${p.name}` }));
      setProjectOptionsLocal(opts);
    } catch (e) {
      setProjectOptionsLocal([]);
    } finally {
      setProjectLoadingLocal(false);
    }
  };
  const execApplyToCustomer = () => {
    const v = form.getFieldsValue();
    if (!v.customer_id) { message.warning('请输入客户ID'); return; }
    confirmRun(() => onApplyToCustomer(v.customer_id, mode === 'overwrite'));
  };
  const execApplyToProject = () => {
    const v = form.getFieldsValue();
    if (!v.customer_id || !v.project_id) { message.warning('请输入客户ID与项目ID'); return; }
    confirmRun(() => onApplyToProject(v.customer_id, v.project_id, mode === 'overwrite'));
  };
  const confirmRun = (runner: () => void) => {
    Modal.confirm({
      title: mode === 'overwrite' ? '对齐并覆盖（强制）' : '仅补齐缺失（安全）',
      content: (
        <div>
          <div>当前模式：{mode === 'overwrite' ? '对齐并覆盖（强制以系统为准）' : '仅补齐缺失（已有不动）'}</div>
          <div className="text-xs text-gray-500 mt-1">建议先在小范围试运行，再批量执行；执行前可先"预览变更"。</div>
        </div>
      ),
      okText: '确认执行',
      cancelText: '取消',
      onOk: runner,
    });
  };
  return (
    <div className="bg-white p-4 rounded border">
      <div className="font-semibold mb-2">规则下发</div>
      <div className="mb-2">
        <Radio.Group value={mode} onChange={(e) => setMode(e.target.value)}>
          <Radio value="fill">仅补齐缺失（安全）</Radio>
          <Radio value="overwrite">对齐并覆盖（强制）</Radio>
        </Radio.Group>
      </div>
      <Form form={form} layout="inline">
        <Form.Item label="客户" name="customer_id" rules={[{ required: true }] }>
          <Select
            placeholder="选择客户（支持模糊搜索）"
            showSearch
            allowClear
            style={{ width: 280 }}
            loading={customerLoadingLocal}
            onFocus={ensureCustomersLoadedLocal}
            optionFilterProp="label"
            defaultActiveFirstOption
            options={customerOptionsLocal}
            onChange={() => { form.setFieldsValue({ project_id: undefined }); setProjectOptionsLocal([]); }}
          />
        </Form.Item>
        <Form.Item label="项目" name="project_id">
          <Select
            placeholder={form.getFieldValue('customer_id') ? '选择项目（支持模糊搜索）' : '先选择客户'}
            showSearch
            allowClear
            style={{ width: 320 }}
            loading={projectLoadingLocal}
            disabled={!form.getFieldValue('customer_id')}
            onFocus={() => searchProjectsLocal('')}
            onSearch={(val) => searchProjectsLocal(val)}
            filterOption={false}
            defaultActiveFirstOption
            options={projectOptionsLocal}
          />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button onClick={execApplyToCustomer}>应用到客户</Button>
            <Button type="primary" onClick={execApplyToProject}>应用到项目</Button>
          </Space>
        </Form.Item>
      </Form>
      <div className="text-xs text-gray-500 mt-2">
        · 仅补齐缺失：只创建目标中不存在的同键规则，已有不改。<br/>
        · 对齐并覆盖：同键规则以系统为准更新，不存在的会创建。
      </div>
    </div>
  );
};

export default SystemBillingPage;


